import common from './common'
import featuresPay from './feature'

const hi = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "उत्पाद/प्रकार",
        serialNumber: "क्रम संख्या",
        noProductsFound: "कोई उत्पाद नहीं मिला",
        searchByProductSku: "उत्पाद/SKU द्वारा खोजें",
        searchSerialNumbers: "क्रम संख्या खोजें",
        transactionDetails: "लेनदेन विवरण",
        notAvailable: "लागू नहीं",
        mainWarehouse: "मुख्य गोदाम"
    },
    new_build_banner: {
        title: 'नया संस्करण:',
        is_available: 'अब उपलब्ध है',
        fallback_title: 'ऐप का नया संस्करण उपलब्ध है',
        desc: 'नवीनતમ सुविधाओं और सुधारों को प्राप्त करने के लिए रिफ्रेश करें।',
        refreshing: 'रिफ्रेश हो रहा है…',
        refresh_now: 'अभी रिफ्रेश करें',
        later: 'बाद में',
        you_are_on: "आप अभी इस पर हैं"
    },
    short: {
        finance: 'वित्त',
        stock: 'स्टॉक'
    },
    onboarding: {
        welcome: 'स्वागत है!',
        step: {
            product: {
                totalBreakdown: 'कुल ब्रेकडाउन',
                overallFulfilment: 'कुल पूर्ति',
                totalShippedQty: 'कुल भेजी गई मात्रा',
                totalReceivedQty: 'कुल प्राप्त मात्रा',
                totalOrderedQty: 'कुल ऑर्डर की गई मात्रा',
                totalShippedOrdered: 'कुल भेजी गई / ऑर्डर की गई',
                totalReceivedOrdered: 'कुल प्राप्त / ऑर्डर की गई',
                viewQty: 'मात्रा देखें',
                fetchingQty: 'मात्रा विवरण प्राप्त किया जा रहा है...',
                noStockInfo: 'कोई स्टॉक जानकारी नहीं मिली',
                title: '65% प्राप्त हुआ',
                description: 'आपकी महान सफलता की शुरुआत के लिए केवल 2 कदम बाकी हैं!',
                Warehouse: "गोदाम",
            },
            stock: {
                title: '95% लगभग पूरा!!',
                description: 'आपकी महान सफलता की शुरुआत के लिए बस एक कदम और बचा है! अभी इसे समाप्त करें।'
            }
        },
        business: {
            title: 'व्यापार सफलतापूर्वक बनाया गया!',
            description: 'अभिनंदन! आपका व्यापार पंजीकृत हो चुका है।'
        },
        product: {
            title: 'अपना पहला उत्पाद जोड़ें',
            description: 'स्टॉक रिकॉर्ड करने के लिए एक उत्पाद जोड़ें।',
            Warehouse: "गोदाम",
        },
        stock: {
            title: 'स्टॉक जोड़ने की कोशिश करें',
            description: 'आने वाले और जाने वाले स्टॉक को रिकॉर्ड करना शुरू करें।'
        },
        action: {
            add_business: {
                title: 'व्यापार बनाएं',
                description: 'क्या आप एक नया व्यापार बनाना चाहते हैं? यहाँ क्लिक करें।'
            },
            join_business: {
                title: 'व्यापार में शामिल हों',
                description: 'क्या आपके पास एक निमंत्रण कोड है? यहाँ शामिल हों।'
            }
        }
    },

    business: {
        title: 'एक व्यापार चुनें, नया बनाएं, या शामिल हों',
        add_business: {
            title: 'नया व्यापार बनाएं',
            name: 'व्यापार का नाम',
            name_placeholder: 'नाम दर्ज करें',
            category: 'व्यापार श्रेणी',
            category_placeholder: 'श्रेणी चुनें',
            button: 'व्यापार बनाएं'
        },
        edit_business: {
            title: 'व्यापार संपादित करें'
        },
        join_business: {
            title: 'व्यापार में शामिल हों',
            input_code: 'नीचे निमंत्रण कोड दर्ज करें:',
            field_placeholder: 'निमंत्रण कोड',
            confirm_title: 'शामिल हों',
            confirm_text: 'आप टीम का हिस्सा बन जाएंगे '
        },
        no_business: 'कोई व्यापार उपलब्ध नहीं है',
        create_or_join: 'एक व्यापार बनाएं या शामिल हों',
        message: {
            saved: 'व्यापार सफलतापूर्वक सहेजा गया!'
        },
        settings: {
            isNegativeTransactionDisabled: 'नेगेटिव स्टॉक ट्रांजेक्शन',
            isNegativeTransactionDisabledHint: 'इसे चालू करके आप उन ट्रांजेक्शन को रोक सकते हैं जो नेगेटिव स्टॉक का कारण बन सकते हैं।',
            negativeStockError: 'नेगेटिव स्टॉक ट्रांजेक्शन अक्षम हैं'
        }
    },
    profile: {
        edit_profile: {
            title: 'प्रोफ़ाइल संपादित करें',
            name: 'पूरा नाम',
            name_placeholder: 'पूरा नाम दर्ज करें',
            email: 'ईमेल',
            phone_number: 'फोन नंबर'
        },
        message: {
            required_name: 'नाम आवश्यक है'
        }
    },
    product: {
        weightedAverageCost: 'भारित औसत लागत',
        weightedAverageValueLabel: 'भारित औसत मूल्य',
        Product: 'उत्पाद',
        hideZeroStock: 'शून्य स्टॉक छिपाएं',
        allVariants: 'सभी वेरिएंट',
        choose_product: 'उत्पाद चुनें',
        choose_product_empty: 'उत्पाद चुनें और मात्रा दर्ज करें',
        search: {
            placeholder: 'नाम से खोजें',
            tooltip: 'स्कैनर खोलें',
            Warehouse: "गोदाम",
        },
        column: {
            image: 'फोटो',
            name: 'नाम',
            price: 'कीमत',
            buying_price: 'खरीद मूल्य',
            selling_price: 'बेचने की कीमत',
            sku: 'SKU',
            stock: 'स्टॉक',
            quantity: 'मात्रा',
            latest_stock: 'शेष',
            product_deleted: 'उत्पाद हटा दिया गया है',
            info_not_found: 'जानकारी उपलब्ध नहीं है',
            expired_date: 'समाप्ति तिथि',
            invoice: 'इनवॉइस'
        },
        no_product: 'कोई उत्पाद उपलब्ध नहीं है',
        no_product_subtitle: 'स्टॉक, मूल्य निर्धारण और बिक्री पर नज़र रखने के लिए अपना पहला उत्पाद जोड़ें।',
        create_first_product: 'अपना पहला उत्पाद बनाएं',
        add_product: {
            sku: 'उत्पाद कोड',
            sku_placeholder: 'उत्पाद कोड। उदाहरण: 12345',
            name: 'उत्पाद नाम',
            name_placeholder: 'उत्पाद नाम दर्ज करें',
            initial_stock: 'आरंभिक स्टॉक',
            initial_stock_placeholder: 'आरंभिक स्टॉक दर्ज करें',
            buying_price: 'खरीद मूल्य',
            buying_price_placeholder: 'खरीद मूल्य दर्ज करें',
            selling_price: 'बेचने की कीमत',
            selling_price_placeholder: 'बेचने की कीमत दर्ज करें',
            category: 'श्रेणी',
            category_placeholder: 'श्रेणी चुनें',
            add_selling_price: 'थोक मूल्य जोड़ें',
            expired_date: 'समाप्ति तिथि',
            expired_date_placeholder: 'तारीख चुनें',
            description: 'विवरण',
            description_placeholder: 'विवरण दर्ज करें',
            Warehouse: "गोदाम",
        },
        choose_selling_price: 'बेचने की कीमत चुनें',
        selling_price: 'बेचने की कीमत',
        total_product: 'कुल उत्पाद',
        total_quantity: 'कुल स्टॉक',
        total_buying_price: 'कुल खरीद मूल्य',
        total_selling_price: 'कुल बेचने की कीमत',
        message: {
            required_name: 'उत्पाद का नाम आवश्यक है',
            required_sku: 'SKU आवश्यक है',
            required_quantity: 'आरंभिक स्टॉक आवश्यक है',
            invalid_input_qty: 'अवैध स्टॉक मात्रा',
            required_buying_price: 'खरीद मूल्य आवश्यक है',
            required_selling_price: 'बेचने की कीमत आवश्यक है',
            required_selling_price_name: 'बेचने की कीमत का नाम आवश्यक है',
            required_selling_price_price: 'बेचने की कीमत आवश्यक है'
        },
        viewMore: 'अधिक देखें',
        WarehouseDetails: 'गोदाम विवरण',
        WarehouseName: 'गोदाम का नाम',
        AddWarehouse: 'गोदाम जोड़ें',
        WarehouseQty: 'गोदाम मात्रा',
        Warehouse: 'गोदाम',
        Warehouses: 'गोदाम',
        Variants: 'संस्करण',
        VariantName: 'संस्करण का नाम',
        productVariant: 'उत्पाद संस्करण',
        AddVariant: 'संस्करण जोड़ें',
        TranferItem: 'आइटम स्थानांतरित करें',
        AddUnit: 'नई इकाई',
        InitialStkWarehouse: 'संस्करण जोड़ने के लिए प्रारंभिक स्टॉक आवश्यक है',
        InitialStockinwarehouse: 'गोदाम में प्रारंभिक स्टॉक',
        TotalQuantity: 'कुल मात्रा:',
        AddNote: 'नोट जोड़ें (लागत मूल्य)',
        AddNotetitle: 'नोट जोड़ें',
        VariantSuccessMessage: 'उत्पाद संस्करण सफलतापूर्वक अपडेट किया गया',
        Next: 'अगला',
        Submit: 'सबमिट करें',
        INACTIVE: 'निष्क्रिय',
        errorone: 'ओह! अनुरोधित मात्रा',
        errortwo: 'आवंटित गोदाम मात्रा से मेल नहीं खाती। कृपया मात्रा समायोजित करें या पुनः भंडार करें।',
        SelectWarehouse: 'गोदाम चुनें',
        SelectVariant: 'वेरिएंट चुनें',
        Discount: 'छूट',
        DiscountDetails: 'छूट विवरण',
        FinalPrice: 'अंतिम मूल्य',
        DiscountType: 'छूट प्रकार',
        DiscountPer: 'छूट %',
        DiscountValue: 'छूट राशि',
        Discountonprice: 'कीमत पर छूट',
        Discountondiscount: 'छूट पर छूट',
        AdditionalDiscount: 'अतिरिक्त छूट',
        SellingPrice: 'विक्रय मूल्य:',
        Save: 'सहेजें',
        OnOriginalPrice: 'मूल कीमत पर',
        OnDiscountedPrice: 'छूट वाली कीमत पर',
        columnSelector: {
            title: 'कॉलम दिखाएं',
            columnsButton: 'कॉलम',
            costPrice: 'खरीद मूल्य',
            sellingPrice: 'बेचने की कीमत',
            sku: 'SKU',
            warehouse: 'गोदाम',
            categories: 'श्रेणियाँ',
            safetyStock: 'सुरक्षा स्टॉक',
            attributes: 'विशेषताएं',
            notes: 'नोट्स',
            description: 'विवरण',
            more: 'और',
            attribute: 'विशेषता',
            attributesTitle: 'विशेषताएं',
            categoriesTitle: 'श्रेणियाँ',
            skuAliases: 'SKU उपनाम'
        }
    },
    note: {
        title: 'नोट्स',
        add: 'नोट जोड़ें',
        no_note: 'कोई नोट उपलब्ध नहीं है'
    },
    settings: {
        category: 'श्रेणी',
        language: 'भाषा',
        switch_business: 'व्यापार बदलें',
        currencySelect: 'मुद्रा',
        languageChangeSuccess: 'मुद्रा सफलतापूर्वक अपडेट हो गई।',
        languageChangeErrorMessage: 'मुद्रा अपडेट करते समय कुछ गलती हो गई।',
        currencyAdded: "मुद्रा सफलतापूर्वक जोड़ी गई",
        currencyDelete: "मुद्रा सफलतापूर्वक हटाई गई",
        Selectyourpreferredlanguage: "अपनी पसंदीदा भाषा चुनें",
    },
    selectProductStock: 'उत्पाद चुनें',
    category: {
        category_list: {
            title: 'उत्पाद श्रेणियाँ'
        },
        add_category: {
            button: 'नई श्रेणी',
            title: 'नई श्रेणी जोड़ें'
        },
        edit_category: {
            title: 'श्रेणी संपादित करें'
        },
        name: 'श्रेणी का नाम',
        name_placeholder: 'श्रेणी का नाम दर्ज करें',
        no_category: 'कोई श्रेणियाँ उपलब्ध नहीं हैं'
    },

    staff: {
        add: 'स्टाफ जोड़ें',
        edit: 'स्टाफ संपादित करें',
        access: {
            stock: 'स्टॉक',
            add_product: 'नया उत्पाद जोड़ें',
            edit_product: 'उत्पाद संपादित करें',
            delete_product: 'उत्पाद हटाएं',
            view_capital_price: 'लागत मूल्य देखें',
            add_category: 'नई श्रेणी जोड़ें',
            edit_category: 'श्रेणी संपादित करें',
            delete_category: 'श्रेणी हटाएं',
            add_supplier: 'नया विक्रेता जोड़ें',
            edit_supplier: 'विक्रेता संपादित करें',
            delete_supplier: 'विक्रेता हटाएं',
            add_customer: 'नया ग्राहक जोड़ें',
            edit_customer: 'ग्राहक संपादित करें',
            delete_customer: 'ग्राहक हटाएं',
            add_staff: 'स्टाफ जोड़ें',
            edit_staff: 'स्टाफ संपादित करें',
            delete_staff: 'स्टाफ हटाएं',
            change_business_profile: 'व्यापार प्रोफ़ाइल बदलें',
            access_by_product_category: 'उत्पाद श्रेणी के आधार पर पहुँच',
            no_category_message: 'आपके पास कोई श्रेणी जोड़ी नहीं गई है। कृपया एक श्रेणी जोड़ें।',
            expenses: 'खर्च',
            view_expenses: 'खर्च देखें',
            add_expenses: 'खर्च जोड़ें',
            edit_expenses: 'खर्च संपादित करें',
            delete_expenses: 'खर्च हटाएं',
            warehouse: 'गोदाम',
            add_new_warehouse: 'नया गोदाम जोड़ें',
            edit_warehouse: 'गोदाम संपादित करें',
            delete_warehouse: 'गोदाम हटाएं',
            transfer_warehouse: 'गोदाम स्थानांतरित करें',
            transfer_warehouse_approval: 'गोदाम स्थानांतरण स्वीकृति',
            access_by_warehouse: 'वेयरहाउस द्वारा एक्सेस',
            no_warehouse_message: 'आपने कोई वेयरहाउस नहीं जोड़ा है। कृपया वेयरहाउस सूची जोड़ें।',
            purchase_order: "खरीद आदेश",
            purchase_order_creation: "खरीद आदेश निर्माण",
            purchase_order_edit: "खरीद आदेश संपादन",
            purchase_order_cancel: "खरीद आदेश रद्द",
            purchase_order_reopen: "खरीद आदेश पुनः खोलें",
            purchase_order_receive: "खरीद आदेश प्राप्ति",
            sales_order: "बिक्री आदेश",
            sales_order_creation: "बिक्री आदेश निर्माण",
            sales_order_edit: "बिक्री आदेश संपादन",
            sales_order_cancel: "बिक्री आदेश रद्द",
            sales_order_reopen: "बिक्री आदेश पुनः खोलें",
            sales_order_receive: "बिक्री आदेश भेजा गया",
            purchase_order_approval: "खरीद आदेश स्वीकृति",
            sales_order_approval: "बिक्री आदेश स्वीकृति",
            can_do_available_warehouse: "उपलब्ध गोदाम",
            add_batch: "बैच निर्माण स्वीकृति"
            ,
            notification: 'सूचना',
            staffNotification: 'सूचना सक्षम करें',
            assignee: "सौंपा गया व्यक्ति",
        },
        no_staff: 'कोई स्टाफ उपलब्ध नहीं है।'
    },
    code: {
        title: 'नया स्टाफ जोड़ा गया!',
        subtitle: 'शामिल होने के लिए नीचे दिए गए आमंत्रण कोड को साझा करें:',
        valid: 'कोड केवल 48 घंटे के लिए मान्य है',
        share: 'व्हाट्सएप पर साझा करें',
        copied: 'कॉपी किया गया!',
        invalid: 'अमान्य कोड!'
    },
    history: {
        no_history: 'कोई इतिहास नहीं।',
        detail: {
            remove: 'इतिहास हटाएं',
            confirm: 'यह सुविधा मौजूदा स्टॉक, इतिहास, और रिपोर्टों को प्रभावित करेगी।'
        },
        no_history_selected: "कोई इतिहास चयनित नहीं है",
        select_history_hint: "विवरण देखने के लिए सूची से किसी इतिहास पर क्लिक करें",
        select_from_left: "बाईं ओर के पैनल से चुनें",
    },
    supplier: {
        add: {
            title: 'विक्रेता जोड़ें'
        },
        edit: {
            title: 'विक्रेता संपादित करें'
        },
        new: 'नया विक्रेता',
        no_supplier: 'कोई विक्रेता उपलब्ध नहीं है।',
        bank: {
            title: 'बैंक विवरण'
        },
        note: 'नोट्स',
        form: {
            name: {
                label: 'विक्रेता का नाम',
                placeholder: 'विक्रेता का नाम दर्ज करें',
                placheolder_not_mandatory: 'नाम दर्ज करें ',
                error: {
                    required: 'नाम खाली नहीं हो सकता'
                }
            },
            contact: {
                label: 'संपर्क नंबर',
                placeholder: '6281234567890',
                error: {
                    required: 'संपर्क नंबर खाली नहीं हो सकता',
                    invalid: 'अमान्य नंबर। इसमें देश का कोड शामिल होना चाहिए'
                }
            },
            bank_name: {
                label: 'बैंक का नाम',
                placeholder: 'बैंक का नाम दर्ज करें'
            },
            bank_account_name: {
                label: 'खाता धारक का नाम',
                placeholder: 'खाता धारक का नाम दर्ज करें'
            },
            bank_account_number: {
                label: 'खाता नंबर',
                placeholder: 'खाता नंबर दर्ज करें'
            },
            note: {
                label: 'नोट्स',
                placeholder: 'नोट्स जोड़ें'
            },
            openingBalance: {
                addBtn: 'प्रारंभिक शेष जोड़ें',
                label: 'प्रारंभिक शेष (Opening Balance)',
                placeholder: 'प्रारंभिक शेष दर्ज करें',
                error: {
                    negative: 'प्रारंभिक शेष नकारात्मक नहीं हो सकता'
                }
            }
        },
        choose: 'विक्रेता चुनें'
    },
    customer: {
        add: {
            title: 'ग्राहक जोड़ें'
        },
        edit: {
            title: 'ग्राहक संपादित करें'
        },
        new: 'नया ग्राहक',
        no_customer: 'कोई ग्राहक उपलब्ध नहीं है।',
        note: 'नोट्स',
        form: {
            name: {
                label: 'ग्राहक का नाम',
                placeholder: 'ग्राहक का नाम दर्ज करें',
                placheolder_not_mandatory: 'नाम दर्ज करें',
                error: {
                    required: 'नाम खाली नहीं हो सकता'
                }
            },
            contact: {
                label: 'संपर्क नंबर',
                placeholder: '6281234567890',
                error: {
                    required: 'संपर्क नंबर खाली नहीं हो सकता',
                    invalid: 'अमान्य नंबर। इसमें देश का कोड शामिल होना चाहिए'
                }
            },
            address: {
                label: 'पता',
                placeholder: 'पता दर्ज करें'
            },
            note: {
                label: 'नोट्स',
                placeholder: 'नोट्स जोड़ें'
            },
            openingBalance: {
                addBtn: 'प्रारंभिक शेष जोड़ें',
                label: 'प्रारंभिक शेष (Opening Balance)',
                placeholder: 'प्रारंभिक शेष दर्ज करें',
                error: {
                    negative: 'प्रारंभिक शेष नकारात्मक नहीं हो सकता'
                }
            }
        },
        choose: 'ग्राहक चुनें',
        report: {
            view: 'खरीदार रिपोर्ट देखें',
            title: 'खरीदार रिपोर्ट',
            no_report: 'चुने हुए तारीख पर खरीदार के लिए कोई रिपोर्ट नहीं है।',
            column: {
                name: 'नाम',
                total_transaction: 'कुल लेन-देन',
                total_amount: 'कुल बिक्री',
                total_profit: 'कुल लाभ'
            }
        }
    },
    confirm_delete: 'क्या आप सुनिश्चित हैं कि आप इस डेटा को हटाना चाहते हैं?',
    report: {
        title: 'रिपोर्ट'
    },
    accounting: {
        download_pdf_report: 'PDF डाउनलोड करें',
        title: 'लेखांकन',
        view_report: 'वित्तीय रिपोर्ट देखें',
        dashboard_title: 'वित्तीय रिपोर्ट',
        stats: 'आंकड़े',
        accounting_report: 'लेखांकन रिपोर्ट',
        filter: {
            date: {
                placeholder: 'तारीख़ चुनें',
                submit: 'लागू करें',
                cancel: 'फ़िल्टर रिसेट करें'
            },
            timeframe: {
                day: 'दैनिक',
                week: 'साप्ताहिक',
                month: 'मासिक',
                year: 'वार्षिक'
            }
        },
        total_sales: 'कुल बिक्री',
        total_purchases: 'कुल खरीद',
        total_profit: 'कुल लाभ',
        total_expenses: 'कुल खर्च',
        assets_value: 'वर्तमान संपत्ति मूल्य',
        total_current_cogs_value: 'कुल वर्तमान COGS मूल्य',
        current_asset_selling_price: 'वर्तमान संपत्ति विक्रय मूल्य',
        total_selling_price: 'कुल विक्रय मूल्य',
        table: {
            date: 'तारीख़',
            sales: 'बिक्री',
            purchases: 'खरीद',
            profit: 'लाभ',
            expenses: 'खर्च'
        },
        no_data: 'कोई डेटा उपलब्ध नहीं है।'
    },
    stock_report: {
        title: 'स्टॉक रिपोर्ट',
        view: 'स्टॉक रिपोर्ट देखें',
        allStaffPlaceHolder: 'सभी स्टाफ',
        no_report: 'चुने गए दिनांक या स्टाफ के लिए कोई स्टॉक रिकॉर्ड नहीं हैं।',
        column: {
            total_product: 'वर्तमान उत्पाद प्रकार',
            total_product_quantity: 'कुल वर्तमान उत्पाद'
        }
    },
    subscription: {
        paywall_small: {
            title: 'वीआईपी फीचर',
            description:
                'इस फीचर के लिए आपका ट्रायल अवधि समाप्त हो गया है। इस स्थानीय ऐप के विकास का समर्थन करने के लिए सब्सक्राइब करें।',
            button: 'सब्सक्रिप्शन योजनाएँ देखें'
        }
    },
    payment: {
        order: {
            title: 'भुगतान'
        }
    },
    imageUploadMessage: {
        uploadSize: 'छवि का आकार 5MB से अधिक नहीं होना चाहिए!',
        failedMessage: 'आइटम छवि अपलोड करने में विफल, कृपया फिर से प्रयास करें!',
        successUpload: 'छवि सफलतापूर्वक अपलोड की गई!',
        failedUIError: 'छवि को हटाने में विफल, कृपया फिर से प्रयास करें!',
        SuccessErrorImage: 'छवि सफलतापूर्वक हटा दी गई है!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'उत्पाद का नाम',
        categoryLabel: 'श्रेणी',
        BuyingPriceLabel: 'खरीद मूल्य',
        SellingLabel: 'बेचने की कीमत',
        StockLabel: 'स्टॉक'
    },
    historyColumns: {
        Transactionlabel: 'लेन-देन प्रकार',
        Locallabel: 'स्थानीय समय',
        Createdlabel: 'द्वारा बनाया गया',
        Vendorlabel: 'विक्रेता का नाम',
        Buyerlabel: 'खरीदार का नाम',
        SKUlabel: 'SKU',
        Productlabel: 'उत्पाद का नाम',
        Categorylabel: 'श्रेणी',
        Buyinglabel: 'खरीद मूल्य',
        Sellinglabel: 'बिक्री मूल्य',
        Initiallabel: 'प्रारंभिक स्टॉक',
        Finallabel: 'अंतिम स्टॉक',
        Stocklabel: 'स्टॉक परिवर्तन'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'उत्पाद का नाम',
        categoryLabel: 'श्रेणी',
        buyingPriceLabel: 'खरीद मूल्य',
        sellingPriceLabel: 'बेचने का मूल्य',
        stockInLabel: 'स्टॉक इन',
        stockOutLabel: 'स्टॉक आउट',
        remainingStockLabel: 'बचा हुआ स्टॉक',
        openStockLabel: 'प्रारंभिक स्टॉक',
        weightedAverageCost: 'भारित औसत लागत',
        weightedAverageCostLabel: 'भारित औसत लागत',
        weightedAverageValueLabel: 'भारित औसत मूल्य'
    },
    accountingReportColumns: {
        dateRange: 'तारीख सीमा',
        reportingPeriod: 'रिपोर्टिंग अवधि',
        reportGenerate: 'रिपोर्ट तैयार',
        warehouse: 'गोदाम',
        labelDate: 'तारीख',
        labelSales: 'बिक्री',
        labelPurchases: 'खरीद',
        labelProfit: 'लाभ',
        labelExpenses: 'खर्च',
        reportOptions: 'रिपोर्ट कॉलम',
        summaryCards: 'सारांश कार्ड',
        grandTotal: 'कुल योग',
        continued: 'जारी',
        subtotal: 'उप-कुल',
        page: 'पृष्ठ'
    },
    customerReportColumns: {
        labelName: 'नाम',
        labelTotalTransaction: 'कुल लेन-देन',
        labelTotalSales: 'कुल बिक्री',
        labelTotalProfit: 'कुल लाभ'
    },
    scannerDialog: {
        finished: 'समाप्त',
        reduce: 'कम करो',
        successfull: 'सफल',
        searching: 'खोज रहा...',
        title: 'स्कैनर सक्रिय है। इसे बारकोड की ओर निर्देशित करें!'
    },
    historyFilter: {
        SelectBuyer: 'खरीदार चुनें',
        SelectVendor: 'विक्रेता चुनें'
    },
    productStockFilter: {
        StockLowtoHigh: 'स्टॉक कम से अधिक',
        StockHightoLow: 'स्टॉक अधिक से कम',
        AlphabetAZ: 'अक्षर A-Z',
        AlphabetZA: 'अक्षर Z-A'
    },
    minimizeTitle: 'स्कैनर सक्रिय',
    security_guarantee: {
        title: 'डेटा सुरक्षा सुनिश्चित है'
    },
    invoice: {
        invoicePlaceholder: 'इनवॉइस नंबर',
        invoiceTitle: 'इनवॉइस',
        manageInvoiceAddress: 'इनवॉइस पता प्रबंधित करें',
        selectOrManageAddresses: 'कस्टम इनवॉइस पते चुनें, संपादित करें या बनाएं',
        useBusinessProfileAddress: 'व्यवसाय प्रोफाइल पता उपयोग करें',
        noCustomAddressesFound: 'कोई कस्टम पता नहीं जोड़ा गया',
        createCustomAddressDesc: 'डिफ़ॉल्ट व्यवसाय प्रोफाइल डेटा के बजाय अपने इनवॉइस पर प्रिंट करने के लिए कस्टम बिलिंग या शाखा पते जोड़ें।',
        defaultFromBusinessProfile: 'व्यवसाय प्रोफाइल से डिफ़ॉल्ट',
        editInvoiceAddress: 'इनवॉइस पता संपादित करें',
        createNewInvoiceAddress: 'नया इनवॉइस पता बनाएं',
        logoHeaderImage: 'लोगो / हेडर छवि',
        deleteInvoiceAddress: 'इनवॉइस पता हटाएं?',
        deleteAddressConfirmText: 'क्या आप निश्चित रूप से इस इनवॉइस पते को हटाना चाहते हैं? यह क्रिया वापस नहीं ली जा सकती।'
    },
    ManageInvoiceAddress: 'इनवॉइस पता प्रबंधित करें',
    SelectOrManageAddresses: 'कस्टम इनवॉइस पते चुनें, संपादित करें या बनाएं',
    UseBusinessProfileAddress: 'व्यवसाय प्रोफाइल पता उपयोग करें',
    CreateNewAddress: 'नया पता बनाएं',
    UpdatingList: 'सूची अपडेट हो रही है...',
    NoCustomAddressesFound: 'कोई कस्टम पता नहीं जोड़ा गया',
    CreateCustomAddressDesc: 'डिफ़ॉल्ट व्यवसाय प्रोफाइल डेटा के बजाय अपने इनवॉइस पर प्रिंट करने के लिए कस्टम बिलिंग या शाखा पते जोड़ें।',
    DefaultFromBusinessProfile: 'व्यवसाय प्रोफाइल से डिफ़ॉल्ट',
    EditInvoiceAddress: 'इनवॉइस पता संपादित करें',
    CreateNewInvoiceAddress: 'नया इनवॉइस पता बनाएं',
    LogoHeaderImage: 'लोगो / हेडर छवि',
    UploadingImage: 'छवि अपलोड हो रही है...',
    UploadImage: 'छवि अपलोड करें',
    BusinessName: 'व्यवसाय का नाम',
    AddressDetails: 'पता विवरण',
    PhoneNumber: 'फोन नंबर',
    EmailAddress: 'ईमेल पता',
    DeleteInvoiceAddress: 'इनवॉइस पता हटाएं?',
    DeleteAddressConfirmText: 'क्या आप निश्चित रूप से इस इनवॉइस पते को हटाना चाहते हैं? यह क्रिया वापस नहीं ली जा सकती।',
    stocklowreport: {
        no_stocklowreport_one: 'सुरक्षा स्टॉक सेटिंग्स वाले कोई आइटम नहीं हैं।',
        no_stocklowreport_two: 'कृपया सुरक्षा स्टॉक मात्रा जोड़ें।',
        currentStock: 'वर्तमान स्टॉक',
        safetyStock: 'सुरक्षा स्टॉक',
        pricing: 'मूल्य निर्धारण',
        costPrice: 'लागत मूल्य',
        sellingPrice: 'विक्रय मूल्य',
        productInfo: 'उत्पाद की जानकारी',
        category: 'श्रेणी',
        description: 'विवरण',
        no_description: 'कोई विवरण नहीं जोड़ा गया',
        variants: 'वेरिएंट',
        unitsOnHand: 'उपलब्ध इकाइयाँ',
        minimumThreshold: 'न्यूनतम सीमा',
        adjust: 'समायोजित करें',
        all: 'सभी',
        lowStock: 'कम स्टॉक',
        variantsDetails: 'वेरिएंट का विवरण',
        qty: 'मात्रा',
        addSafetyStock: 'सुरक्षा स्टॉक जोड़ें',
        searchByNameSku: 'नाम/SKU से खोजें',
        safetyStockShort: 'स',
        warehouseSafetyStock: 'वेयरहाउस सुरक्षा स्टॉक'
    },
    low_alert_stock: 'सुरक्षा स्टॉक मात्रा दर्ज करें',
    lowStockAlertNotify: 'जब स्टॉक निर्धारित मात्रा से कम हो जाएगा, तो आपको एक सूचना मिलेगी।',
    applyButtonStockAlert: 'लागू करें',
    cancelButtonStockAlert: 'रद्द करें',
    searchProductLabel: 'उत्पाद खोजें...',
    successfullyAddedSafetyStock: 'सुरक्षा स्टॉक सफलतापूर्वक अपडेट किया गया',
    safety_Stock: 'सुरक्षा स्टॉक',
    safety_stock_placeholder: 'सुरक्षा स्टॉक दर्ज करें',
    lowStockDetailsInfo: {
        ProductCode: 'उत्पाद कोड',
        SafetyStock: 'सुरक्षा स्टॉक',
        Stock: 'स्टॉक',
        CostPrice: 'लागत मूल्य',
        SellingPrice: 'बिक्री मूल्य',
        Category: 'श्रेणी',
        Description: 'विवरण',
        ExpirationDate: 'समाप्ति तिथि'
    },
    CustomLang: {
        Attribute: 'गुण',
        AddAttribute: 'गुण जोड़ें',
        EditAttribute: 'गुण संपादित करें',
        CustomLabePlaceholder: 'गुण का नाम दर्ज करें',
        CustomLabePlaceholderSelect: 'प्रकार चुनें',
        AddMoreAttribute: 'और गुण जोड़ें',
        ItemAttribute: 'वस्तु का गुण',
        TableName: 'नाम',
        TableType: 'प्रकार',
        TableAction: 'क्रिया',
        TableDelete: 'हटाएं',
        TableEdit: 'संपादित करें',
        deleteMessage: 'गुण सफलतापूर्वक हटाया गया',
        editSuccessMessage: 'गुण सफलतापूर्वक अपडेट किया गया',
        AddSuccessMessage: 'गुण सफलतापूर्वक जोड़ा गया',
        AddAtt: 'जोड़ें',
        EditAtt: 'संपादित करें',
        SubmitAtt: 'जमा कर रहे हैं...'
    },
    Expenses: {
        ExpensesTitle: 'खर्चे',
        AddExpenses: 'खर्चे जोड़ें',
        ExpenseCategory: 'खर्चे की श्रेणी',
        NoExpenseCategory: 'कोई खर्च श्रेणी नहीं',
        AddExpenseCategory: 'खर्चे की श्रेणी जोड़ें',
        SelectExpenseCategory: 'खर्चे की श्रेणी चुनें',
        NoExpenses: 'कोई खर्चा नहीं',
        ExpensesSuccess: 'खर्चा सफलतापूर्वक बनाया गया',
        ExpensesSuccessEdit: 'खर्चा सफलतापूर्वक अपडेट किया गया',
        ExpensesCategoryName: 'खर्चे की श्रेणी का नाम',
        ExpensesSuccessDelete: 'खर्चा सफलतापूर्वक हटाया गया',
        TotalSpentThisWeek: 'इस सप्ताह कुल खर्च',
        AddNEC: "नई व्यय श्रेणी जोड़ें",
        NC: "नई व्यय श्रेणी",
        EditNEC: "व्यय श्रेणी संपादित करें"
    },
    Manufacturing: {
        ProducedProduct: "उत्पादित उत्पाद",
        QuantityManufactured: "निर्मित मात्रा",
        UnitCost: "इकाई लागत",
        RawMaterialsTotal: "कुल कच्चा माल",
        TotalManufacturingCost: "कुल विनिर्माण लागत",
        NoRawMaterialsConsumed: "कोई कच्चा माल उपभोग नहीं हुआ।",
        CostBreakdown: "लागत विवरण",
        GeneratedBatch: "उत्पादित बैच",
        StoredBinLocation: "संग्रहीत बिन स्थान",
        NoManufacturingTransactionsFound: "कोई विनिर्माण लेनदेन नहीं मिला",
        AddManufacture: 'निर्माण विवरण जोड़ें',
        Manufacturing: 'निर्माण',
        RawMaterials: 'कच्चा माल',
        AdditonCosts: 'अतिरिक्त लागत',
        RawMaterial: 'कच्चा माल',
        AdditonCost: 'अतिरिक्त लागत',
        TotalCost: 'कुल लागत',
        AddRawMaterial: 'के लिए कच्चा माल जोड़ें',
        AddAdditonCost: 'के लिए अतिरिक्त लागत जोड़ें',
        AddMore: 'और जोड़ें',
        Add: 'जोड़ें',
        Update: 'अपडेट करें',
        Updating: 'सबमिट कर रहा है...',
        ProductRequired: 'उत्पाद आवश्यक है',
        QuantityRequired: 'मात्रा आवश्यक है',
        ChargeRequired: 'शुल्क आवश्यक है',
        EstimatedCostRequired: 'अनुमानित लागत आवश्यक है',
        PurchasePriceRequired: 'खरीद मूल्य आवश्यक है',
        SelectCharge: 'शुल्क चुनें',
        EstimatedCost: 'अनुमानित लागत',
        SelectProduct: 'एक उत्पाद चुनें',
        Quantity: 'मात्रा',
        ManufactureDetails: 'निर्माण विवरण',
        BuyingPrice: 'खरीद मूल्य',
        LabourCharge: 'मजदूरी शुल्क',
        ElectricityCost: 'बिजली लागत',
        PackagingCharge: 'पैकेजिंग शुल्क',
        LogisticCost: 'लॉजिस्टिक लागत',
        OtherCharges: 'अन्य शुल्क',
        Save: 'विवरण सहेजें',
        PurchasePrice: 'खरीद मूल्य',
        Date: 'तारीख',
        For: 'के लिए',
        PurchaseRate: 'खरीद दर (मूल्य)',
        Scrolltoloadmore: 'अधिक लोड करने के लिए स्क्रॉल करें...',
        Noproductsfound: 'कोई उत्पाद नहीं मिला',
        ManufacturingQuantity: 'निर्माण मात्रा',
        ManufactureAddedSuccess: 'निर्माण विवरण सफलतापूर्वक अपडेट किया गया'
    },
    Warehouses: {
        transferOrder: 'सामान स्थानांतरित करें',
        AddTransferOrder: 'सामान जोड़ें',
        NewWarehouse: 'नया गोदाम',
        newHead: 'एकाधिक गोदामों को प्रबंधित करना शुरू करें!',
        headTwo: 'अपने स्टॉक को कई गोदामों में सहजता से ट्रैक और प्रबंधित करें',
        EnableWarehouse: 'गोदाम सक्षम करें',
        EnableWarehouse2: 'गोदाम सक्षम करें',
        OrganizationPrimary: 'संगठन का प्राथमिक गोदाम',
        Edit: 'संपादित करें',
        AreEnableWarehouse: 'क्या आप वाकई गोदाम को सक्षम करना चाहते हैं?',
        Confirm: 'पुष्टि करें',
        Cancel: 'रद्द करें',
        WarehouseCreatedSuccessfully: 'गोदाम सफलतापूर्वक बनाया गया',
        MarkAsOP: 'संगठन का प्राथमिक गोदाम चिह्नित करें',
        MarkAsInAct: 'निष्क्रिय के रूप में चिह्नित करें',
        MarkAsAct: 'सक्रिय के रूप में चिह्नित करें',
        MarkedAsInactive: 'गोदाम को सफलतापूर्वक निष्क्रिय किया गया',
        MarkedAsActive: 'गोदाम को सफलतापूर्वक सक्रिय किया गया',
        MarkedAsOP: 'गोदाम को संगठन का प्राथमिक के रूप में सफलतापूर्वक चिह्नित किया गया',
        WareDeletedSuccess: 'गोदाम सफलतापूर्वक हटाया गया',
        SuccessfullyUpdatedWarehouse: 'गोदाम को सफलतापूर्वक अपडेट किया गया',
        SuccessfullyCreatedWarehouse: 'गोदाम को सफलतापूर्वक बनाया गया',
        EditWarehouse: 'गोदाम संपादित करें',
        AddWarehouse: 'गोदाम जोड़ें',
        WarehouseNameIsRequired: 'गोदाम का नाम आवश्यक है',
        EnterWarehouseName: 'गोदाम का नाम दर्ज करें',
        EnterEmail: 'ईमेल दर्ज करें',
        EnterPhoneNumber: 'फ़ोन नंबर दर्ज करें',
        Location: 'स्थान...',
        name: 'गोदाम का नाम',
        email: 'ईमेल',
        phoneNumber: 'फ़ोन नंबर',
        location: 'स्थान',
        ViewProducts: 'उत्पाद देखें',
        PageTitle: 'गोदाम',
        noWarehouse: "आपकी खोज से कोई वेयरहाउस मेल नहीं खाता"
    },
    Assets: {
        headerTitle: 'संपत्तियाँ',
        addAssetMessage: 'यहाँ संपत्ति जोड़ें। कर्मचारी को संपत्ति सौंपने के लिए, कर्मचारी के प्रोफाइल पर जाएँ।',
        addAsset: 'संपत्ति जोड़ें',
        editAsset: 'संपत्ति संपादित करें',
        assetCode: 'संपत्ति कोड',
        assetName: 'संपत्ति का नाम',
        assetCategory: 'संपत्ति श्रेणी',
        assetType: 'संपत्ति प्रकार',
        serialNumber: 'सीरियल नंबर',
        location: 'स्थान',
        condition: 'स्थिति',
        selectCondition: 'स्थिति चुनें',
        fair: 'उचित',
        good: 'अच्छा',
        excellent: 'उत्कृष्ट',
        poor: 'खराब',
        notes: 'नोट्स',
        submit: 'जमा करें',
        submitting: 'जमा हो रहा है',
        noCategory: 'कोई श्रेणी नहीं',
        selectCategory: 'श्रेणी चुनें',
        addAssetCat: 'संपत्ति श्रेणी जोड़ें',
        addAssetCatName: 'संपत्ति श्रेणी का नाम',
        edit: 'संपादित करें',
        status: 'स्थिति',
        createdAt: 'निर्मित तिथि',
        viewAsset: 'संपत्ति देखें',
        assignAsset: 'संपत्ति सौंपें',
        conditionRet: 'स्थिति (वापसी पर)',
        searchSelectAssets: 'संपत्ति खोजें/चुनें',
        assetAssigned: 'संपत्ति सफलतापूर्वक सौंपी गई',
        assetReturned: 'संपत्ति सफलतापूर्वक वापस की गई',
        selectAnAsset: 'कृपया एक संपत्ति चुनें',
        action: 'कार्रवाई',
        noAssetAssigned: 'कोई संपत्ति सौंपी नहीं गई',
        reAssigned: 'पुनः सौंपें',
        assignedAssetsList: 'सौंपी गई संपत्तियों की सूची',
        viewHistory: "इतिहास देखें",
        history: "संपत्ति इतिहास",
        loadingHistory: "इतिहास लोड हो रहा है...",
        loadingMore: "अधिक लोड हो रहा है...",
        dateTime: "तारीख और समय",
        staff: "स्टाफ",
        AssignedBy: "द्वारा सौंपा गया",
        assign: "सौंपें",
        return: "वापस करें",
        unknown: "अज्ञात",
        noHistory: "इस संपत्ति के लिए कोई इतिहास उपलब्ध नहीं है।",
        enterReturnNote: "वापसी के लिए नोट दर्ज करें",
        returnNote: "वापसी नोट",
        enterAssignNote: "असाइनमेंट के लिए नोट दर्ज करें",
        assignNote: "असाइनमेंट नोट",
        AddNAC: "नई परिसंपत्ति श्रेणी जोड़ें",
        EditNAC: "परिसंपत्ति श्रेणी संपादित करें",
        others: "अन्य"
    },
    LedgerTransaction: {
        ledgerDetails: 'लेजर विवरण',
        productName: 'उत्पाद का नाम',
        totalQty: 'कुल मात्रा',
        date: 'तारीख',
        receivedAmt: 'प्राप्त राशि',
        paid: 'भुगतान किया',
        discount: 'छूट',
        balance: 'शेष',
        more: 'अधिक',
        total: 'कुल',
        ledgerupdatedsuccessfully: 'लेजर सफलतापूर्वक अपडेट किया गया',
        ledgeraddedsuccessfully: 'लेजर सफलतापूर्वक जोड़ा गया',
        viewLedger: 'लेजर देखें',
        edit: 'संपादित करें',
        create: 'बनाएँ',
        Recieved: 'प्राप्त [स्टॉक में]',
        payMode: 'भुगतान मोड',
        Refno: 'संदर्भ संख्या'
    },
    ExtraField: {
        attachment: 'अटैचमेंट',
        acceptOnlyImg: 'केवल इमेज स्वीकार करें।',
        addAttribute: 'एट्रिब्यूट जोड़ें',
        acceptImgAndDoc: 'इमेज और दस्तावेज़ स्वीकार करें।'
    },
    phoneInvoiceDownload: {
        Variant: "वैरिएंट",
        Warehouse: "वेयरहाउस",
        Bin: "बिन",
        Batch: "बैच",
        Attributes: "विशेषताएं"
    },
    ImportExcel: {
        ImportStockfromExcel: "Excel से स्टॉक आयात करें",
        DragDrop: "अपनी भरी हुई Excel फाइल यहां खींचकर छोड़ें या ब्राउज़ करने के लिए क्लिक करें",
        DT: "टेम्प्लेट डाउनलोड करें",
        GB: "वापस जाएं",
        Downloading: "डाउनलोड हो रहा है...",
        ChangeFile: "फाइल बदलें",
        ReadingExcelfile: "Excel फाइल पढ़ी जा रही है...",
        Processing: "प्रोसेसिंग...",
        submitUpdateStock: "सबमिट करें और स्टॉक अपडेट करें",
        downloadLatestTemplate: "नवीनतम टेम्प्लेट डाउनलोड करें",
        loginRequired: "लॉगिन आवश्यक है"
    },
    stockForm: {
        recordPaymentNow: "अभी भुगतान दर्ज करें",
        recordPaymentDescCustomer: "ग्राहक द्वारा भुगतान की गई राशि दर्ज करें",
        recordPaymentDescSupplier: "आपूर्तिकर्ता द्वारा भुगतान की गई राशि दर्ज करें",
        managePayments: "भुगतान प्रबंधित करें",
        invoice: "इनवॉइस",
        challan: "चालान",
        recordPayment: "भुगतान रिकॉर्ड करें",
        payableAmount: "देय राशि",
        paidAmount: "भुगतान की गई राशि",
        paymentMethod: "भुगतान विधि",
        paymentDate: "भुगतान तिथि",
        reference: "संदर्भ",
        billId: "बिल नंबर",
        importExcel: "एक्सेल से आयात करें",
        noThanks: "नहीं, धन्यवाद",
        checkHistory: "इतिहास देखें",
        wantViewHistory: "क्या आप अपना इतिहास देखना चाहते हैं?",
        enterPayable: "देय राशि दर्ज करें",
        enterPaid: "भुगतान की गई राशि दर्ज करें",
        selectPayment: "भुगतान विधि चुनें",
        attachment: "संलग्नक",
        note: "नोट"
    },
    HistoryEdit: {
        products: "उत्पाद",
        add_product: "उत्पाद जोड़ें",
        paidAmountInvalidMessage: "भुगतान की गई राशि देय राशि से अधिक नहीं हो सकती",
        removingText: "इस उत्पाद को हटाने से इस लेन-देन के दौरान किए गए स्टॉक परिवर्तन वापस हो जाएंगे।",
        remove: "हटाएँ"
    },
    ExcelProduct: {
        uploadFile: "फ़ाइल अपलोड करें",
        dragDrop: "अपनी एक्सेल फ़ाइल खींचें या अपलोड करने के लिए क्लिक करें।",
        parsingFile: "फ़ाइल प्रोसेस की जा रही है",
        fileSelected: "फ़ाइल चयनित",
        reviewImportedData: "नीचे आयात किए गए डेटा की समीक्षा करें। जहाँ संभव हो कॉलम स्वतः मिलाए जाते हैं।",
        changeFile: "फ़ाइल बदलें",
        back: "वापस",
        invalidFileType: "कृपया मान्य एक्सेल फ़ाइल अपलोड करें (.xlsx या .xls)",
        parseExcelError: "एक्सेल पार्स त्रुटि:",
        noData: "अपलोड की गई एक्सेल फ़ाइल में कोई डेटा नहीं है।",
        failedToRead: "एक्सेल फ़ाइल पढ़ने में विफल। कृपया पुनः प्रयास करें।",
        Nodata: "कोई_डेटा_नहीं",
        unableToRead: "फ़ाइल पढ़ने में असमर्थ।",
        buyingMustNumber: "खरीद मूल्य एक संख्या होना चाहिए",
        sellingMustNumber: "बिक्री मूल्य एक संख्या होना चाहिए",
        mustBeNumber: "एक संख्या होनी चाहिए",
        bulkUploadfailed: "बल्क अपलोड विफल",
        importFromExcel: "एक्सेल से आयात करें",
        generating: "जनरेट हो रहा है...",
        downloadTemplate: "टेम्पलेट डाउनलोड करें",
        uploading: "अपलोड हो रहा है...",
        done: "पूर्ण",
        requiredField: "{field} आवश्यक है",
        bulkUpload: "बल्क अपलोड",
        duplicateSku: "डुप्लिकेट SKU पाया गया",
        uploadedSuccessfully: "सभी उत्पाद सफलतापूर्वक अपलोड हो गए!",
        uploadCompleteIssues: "समस्याओं के साथ अपलोड पूरा हुआ",
        uploaded_products: "{count} उत्पाद अपलोड किए गए।",
        failed_products: "{count} असफल हुए।",
        failed_items: "असफल आइटम:"
    },
    Discount: {
        overallDiscount: "कुल छूट",
        final: "अंतिम कुल",
        balanceDue: "बकाया राशि",
        tax: "कर"
    },
    ProductForm: {
        barcodeQuantity: "बारकोड मात्रा दर्ज करें",
        baseUnit: "आधार इकाई (प्राथमिक)",
        addSecondaryUnit: "द्वितीयक इकाई जोड़ें?",
        selectUnit: "इकाई चुनें",
        subUnitDetails: "उप इकाई विवरण",
        subUnit: "उप इकाई",
        selectSubUnit: "उप इकाई चुनें",
        conversionRate: "रूपांतरण दर",
        exampleLogic: "उदाहरण तर्क:",
        example: "यदि आप पेन बॉक्स में बेच रहे हैं, तो आधार इकाई को बॉक्स रखें और 50 के रूपांतरण के साथ एक उप इकाई (पीस) जोड़ें। इसका अर्थ है 1 बॉक्स में 50 पीस होते हैं।",
        basePrice: "आधार मूल्य"
    },
    barcode: {
        settings: 'बारकोड सेटिंग्स',
        labelSize: 'लेबल का आकार',
        customSize: 'कस्टम आकार...',
        widthMm: 'चौड़ाई (मिमी)',
        heightMm: 'ऊंचाई (मिमी)',
        showPrice: 'लेबल पर बिक्री मूल्य दिखाएं',
        noPrices: 'इस उत्पाद के लिए कोई बिक्री मूल्य कॉन्फ़िگر नहीं किया गया है।',
        preview: 'पूर्वावलोकन',
        generate: 'जनरेट करें',
        label: 'लेबल',
        singlePage: 'एकल पृष्ठ',
        downloadOptions: 'डाउनलोड विकल्प',
        chooseLayout: 'बारकोड के लिए लेआउट चुनें',
        allInSinglePage: 'सभी बारकोड एक ही पृष्ठ में जोड़ें।',
        allInA4Grid: 'सभी एक पृष्ठ में',
        allInA4GridSub: 'सभी बारकोड को A4 ग्रिड में व्यवस्थित करता है',
        onePerPage: 'प्रति पृष्ठ एक',
        onePerPageSub: 'प्रत्येक बारकोड अपने स्वयं के लेबल पृष्ठ पर',
        downloadBarcode: 'बारकोड डाउनलोड करें'
    },

    TransferItem: {
        transferItem: "आइटम ट्रांसफर",
        Date: "तारीख",
        Reason: "कारण",
        enterReason: "कारण दर्ज करें",
        Name: "नाम",
        QuantityTransfered: "स्थानांतरित मात्रा",
        SWarehouse: "स्रोत गोदाम",
        SelectSWarehouse: "स्रोत गोदाम चुनें",
        DWarehouse: "गंतव्य गोदाम",
        SelectDWarehouse: "गंतव्य गोदाम चुनें",
        CreatedBy: "निर्माता",
        CreatedTime: "निर्माण समय",
        UpdatedTime: "अपडेट समय",
        NoOrderFound: "कोई ऑर्डर नहीं मिला",
        New: "नया",
        WarehouseItemTransfer: "गोदाम आइटम ट्रांसफर",
        TotalTransfers: "कुल ट्रांसफर",
        EnterReason: "कारण दर्ज करें",
        ItemDetails: "आइटम विवरण",
        CurrentAvailable: "वर्तमान उपलब्धता",
        TransferQty: "ट्रांसफर मात्रा",
        SStock: "स्रोत स्टॉक",
        DStock: "गंतव्य स्टॉक",
        addDescription: "आइटम का विवरण जोड़ें",
        selectVariant: "वेरिएंट चुनें",
        addNewRow: "नई पंक्ति जोड़ें",
        typeOrSelectItem: "खोजने के लिए टाइप करें",
        scrollToLoadMore: "और लोड करने के लिए स्क्रॉल करें",
        noProductsFound: "कोई उत्पाद नहीं मिला",
        selectWarehouse: "गोदाम चुनें"
    },
    Sku: {
        searchSelectProduct: "उत्पाद खोजें / चुनें",
        searchSelectSku: "SKU खोजें / चुनें",
        noSkuFound: "कोई SKU नहीं मिला"
    },
    HistoryPage: {
        addFilter: "फ़िल्टर जोड़ें",
        filtersActive: "सभी फ़िल्टर सक्रिय हैं",
        noProducts: "कोई उत्पाद नहीं",
        download: "डाउनलोड",
        recentlyUpdated: "हाल ही में अपडेट किया गया",
    },
    StockPage: {
        challanNumber: "चालान नंबर",
        subTotal: "उप-योग",
        totalTaxes: "कुल और कर",
        taxInclusive: "कर सहित",
        discountedValue: "छूट के बाद मूल्य",
        taxValue: "कर मूल्य",
        totalAmount: "कुल राशि",
        close: "बंद करें",
        addTax: "कर जोड़ें",
        label: "लेबल",
        enterLabel: "लेबल दर्ज करें",
        taxRate: "कर दर",
        enterTaxRate: "कर दर दर्ज करें",
        selectTaxRate: "कर दर चुनें",
        addNewTax: "नई कर दर जोड़ें",
        discountProducts: "छूट के बाद मूल्य (उत्पाद)",
        taxProducts: "कर मूल्य (उत्पाद)",
        clickAddPayment: "भुगतान जोड़ने के लिए क्लिक करें",
        paidGreaterPayable: "भुगतान की गई राशि देय राशि से अधिक नहीं हो सकती",
        vendorCompulsory: "भुगतान रिकॉर्ड करने के लिए विक्रेता आवश्यक है",
        customerCompulsory: "भुगतान दर्ज करने के लिए ग्राहक आवश्यक है",
        updateInvoiceFormat: "इनवॉइस प्रारूप अपडेट करें",
        updateChallanFormat: "चालान प्रारूप अपडेट करें",
        addPrefix: "प्रीफिक्स जोड़ें",
        prefix: "प्रीफिक्स"
    },
    EditHistoryPage: {
        search_by_notes: "नोट्स द्वारा खोजें",
        alertMessage: "यह परिवर्तन केवल इतिहास में दर्ज किया गया है और वर्तमान स्टॉक को प्रभावित नहीं करता।",
        paymentDetails: "भुगतान विवरण",
        units: "इकाइयाँ",
        customLabels: "कस्टम लेबल",
        value: "मान",
        Order_Info: "ऑर्डर जानकारी",
        percentage: "प्रतिशत",
        Stock_updates_on_submit: "सबमिट पर स्टॉक अपडेट",
        Summary: "सारांश"

    },
    historyCard: {
        paid: "भुगतान किया गया",
        partiallyPaid: "आंशिक रूप से भुगतान किया गया",
        billDate: "बिल की तारीख",
        productDetails: "उत्पाद विवरण",
        paymentsHistory: "भुगतान इतिहास",
        updatePayment: "भुगतान अपडेट करें",
        discounts: "छूट",
        inclusive: "(शामिल)",
        discountOverall: "छूट के बाद मूल्य (कुल)",
        dueAmount: "देय राशि",
        enterPaid: "भुगतान राशि दर्ज करें",
        enterReference: "संदर्भ दर्ज करें",
        enterNote: "नोट दर्ज करें",
        enterInvoice: "इनवॉइस दर्ज करें",
        enterChallan: "चालान दर्ज करें",
        edit: "संपादित"
    },
    printInvoice: {
        billTo: "बिल किया गया",
        ref: "संदर्भ नं.",
        mode: "मोड",
        date: "तारीख",
        amount: "राशि",
        totalPaid: "कुल भुगतान"
    },
    Contact: {
        supplier_required: "स्टॉक इन के लिए आपूर्तिकर्ता आवश्यक है",
        customer_required: "स्टॉक आउट के लिए ग्राहक आवश्यक है",
        key: "कुंजी",
        editHistory: "इतिहास संपादित करें",
        loading: "लोड हो रहा है..."
    },
    AW: {
        availablewarehouse: "उपलब्ध गोदाम",
        visibilityManagement: 'दृश्यता प्रबंधन',
        availablewarehouses: "उपलब्ध गोदाम",
        Active: "सक्रिय",
        LWarehouse: "गोदाम लोड हो रहे हैं...",
        NWForthisProduct: "इस उत्पाद के लिए कोई गोदाम नहीं मिला।",
        of: "का",
        WarehouseAvailabilty: "गोदाम उपलब्धता",
    },
    Currency: {
        searchCurrency: "मुद्राएँ खोजें...",
        addCurrency: "मुद्रा जोड़ें",
        addNewCurrency: "नई मुद्रा जोड़ें",
        editCurrency: "मुद्रा संपादित करें",
        currencySymbol: "मुद्रा प्रतीक",
        currencyName: "मुद्रा नाम",
        enterCurrencySymbol: "मुद्रा प्रतीक दर्ज करें",
        enterCurrencyName: "मुद्रा नाम दर्ज करें"
    },
    NewReportLang: {
        DM: "दैनिक मूवमेंट",
        WR: "वेयरहाउस रिपोर्ट",
        PDM: "प्रोडक्ट दैनिक मूवमेंट",
        TBP: "कुल खरीद मूल्य",
        TPQ: "कुल प्रोडक्ट मात्रा",
        TP: "कुल प्रोडक्ट्स",
        CS: "वर्तमान स्टॉक",
        IV: "इन्वेंट्री वैल्यू",
        DA: "दैनिक औसत",
        TSI: "कुल स्टॉक इन",
        TSO: "कुल स्टॉक आउट",
        TOR: "टर्नओवर दर",
        Tv: "कुल मूल्य",
        AST: "एक्टिव SKU ट्रैकिंग",
        UT: "ट्रैक की गई यूनिट्स",
        SL: "स्टॉक स्तर",
        Value: "मूल्य",
        IO: "इन/आउट",
        T: "टर्नओवर",
        unitsD: "यूनिट्स/दिन",

        Sort: "क्रमबद्ध करें",
        Sort_by: "इसके अनुसार क्रमबद्ध करें",
        Units_available: "उपलब्ध इकाइयाँ",
        Units_unavailable: "अनुपलब्ध इकाइयाँ",
        Current_assets: "चालू परिसंपत्तियाँ",
        Search: "खोजें",

        available: "उपलब्ध",
        assigned: "नियत / सौंपा गया",

        AYSWD: "क्या आप वाकई हटाना चाहते हैं?",
        PTS: "वेयरहाउस सफलतापूर्वक स्थानांतरित किया गया",
        AUS: "परिसंपत्तियाँ सफलतापूर्वक अपडेट की गईं",
        ACS: "परिसंपत्तियाँ सफलतापूर्वक बनाई गईं",
        VSP: "बिक्री मूल्य देखें",
        HUS: "इतिहास सफलतापूर्वक अपडेट किया गया",
    },
    ReplacementReturn: {
        selectProduct: "कृपया एक उत्पाद चुनें",
        selectReplacementProduct: "कम से कम एक रिप्लेसमेंट उत्पाद चुनें",
        validQuantity: "कृपया वैध रिटर्न मात्रा दर्ज करें",
        replacedSuccessfully: "उत्पाद सफलतापूर्वक बदल दिया गया",
        returnSuccessfully: "उत्पाद सफलतापूर्वक वापस किया गया",
        failedProcess: "प्रक्रिया विफल। कृपया पुनः प्रयास करें।",
        return: "वापस करें",
        replace: "बदलें",
        typeSelectProduct: "उत्पाद टाइप करें या चुनें...",
        returnQuantity: "वापसी मात्रा",
        enterQuantity: "मात्रा दर्ज करें",
        replacementDate: "रिप्लेसमेंट तिथि",
        returnDate: "वापसी तिथि",
        chooseCustomer: "ग्राहक चुनें",
        additionalNotes: "अतिरिक्त नोट्स जोड़ें...",
        replacementProducts: "रिप्लेसमेंट उत्पाद",
        addProducts: "और उत्पाद जोड़ें",
        tapSelect: "उपलब्ध उत्पादों से चुनने के लिए टैप करें",
        currently: "वर्तमान में",
        item: "आइटम",
        items: "आइटम",
        selected: "चयनित",
        selectedItems: "चयनित आइटम",
        hideDetails: "अधिक विवरण छिपाएं",
        showDetails: "अधिक विवरण दिखाएं",
        product: "उत्पाद",
        priceLevel: "मूल्य स्तर चुनें",
        customPrice: "कस्टम मूल्य दर्ज करें",
        noReplaceHistory: "कोई रिप्लेसमेंट इतिहास नहीं मिला",
        replaceReturn: "बदलें और वापस करें",
        replaceReturnHistory: "रिप्लेसमेंट और रिटर्न का इतिहास"
    },
    OtherComponent: {
        mfgHistoryTitle: "विनिर्माण इतिहास",
        mfgHistoryDesc: "निर्मित स्टॉक उत्पादों को ट्रैक करें",
        dailyOperation: "दैनिक संचालन",
        freqUsed: "रिकॉर्ड्स को तेजी से अपडेट करने के लिए अक्सर इस्तेमाल की जाने वाली क्रियाएं",
        manageCategory: "श्रेणियां प्रबंधित करें",
        organizeCaterory: "उत्पाद, व्यय और संपत्ति श्रेणियों को व्यवस्थित और प्रबंधित करें",
        businessRecord: "व्यावसायिक रिकॉर्ड",
        organizeRecord: "अपने व्यावसायिक रिकॉर्ड को व्यवस्थित और प्रबंधित करें",
        trackHistory: "इतिहास ट्रैक करें",
        completeTracking: "ऑडिट और ट्रैकिंग के लिए पूर्ण इतिहास",
        Verifyinventorycount: "इन्वेंट्री गिनती सत्यापित करें",
        Exchangerates: "विनिमय दरें",
        Productiontracking: "उत्पादन ट्रैकिंग",
        Fixedassetregister: "स्थिर संपत्ति रजिस्टर",
        Storagelocations: "स्टोरेज लोकेशन",
        warehouseAvailability: 'गोदाम-स्तरीय उत्पाद उपलब्धता',
        Logreviewspend: "खर्च लॉग और समीक्षा करें",
        Productgroupings: "उत्पाद समूहीकरण",
        Classifyexpenditures: "व्यय वर्गीकरण करें",
        Assetclassification: "संपत्ति वर्गीकरण",
        Manageexchanges: "विनिमय प्रबंधित करें",
        Returnauditlog: "रिटर्न ऑडिट लॉग",
        Interlocationmoves: "स्थान-बीच स्थानांतरण",
        Manageoperationscategoriesrecordsandhistory: "संचालन, श्रेणियां, रिकॉर्ड और इतिहास प्रबंधित करें"
    },
    no_permission_dialog: {
        title: 'कोई अनुमति नहीं',
        historyDescription: "आपको लेन-देन इतिहास देखने की अनुमति नहीं है। कृपया अपने व्यवस्थापक से संपर्क करें।",
        replacementHistoryDescription: "आपको रिप्लेसमेंट और रिटर्न इतिहास देखने की अनुमति नहीं है। कृपया अपने व्यवस्थापक से संपर्क करें।",
        transferHistoryDescription: "आपको ट्रांसफर वेयरहाउस इतिहास देखने की अनुमति नहीं है। कृपया अपने व्यवस्थापक से संपर्क करें।"
    },
    OthersHistory: {
        title: "इतिहास प्रबंधित करें",
        transferHistory: "ट्रांसफर इतिहास प्रबंधित करें",
        transactionHistory: "लेन-देन इतिहास प्रबंधित करें",
        replacementHistory: "रिप्लेसमेंट और रिटर्न इतिहास प्रबंधित करें"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "व्यवसाय द्वारा साझा किए गए उत्पादों को देखें और खरीदें।",
        description: "व्यवसाय द्वारा साझा किए गए उत्पादों को देखें।",
        productsAvailable: "उपलब्ध उत्पाद",
        noImageAvailable: "कोई चित्र उपलब्ध नहीं है",
        productDetails: "उत्पाद विवरण",
        inStock: "स्टॉक में उपलब्ध",
        availableVariants: "उपलब्ध विकल्प",
        options: "विकल्प",
        orders: "ऑर्डर"
        ,
        searchProducts: "उत्पाद खोजें...",
        noProductsFound: "कोई उत्पाद नहीं मिला",
        tryDifferentKeyword: "किसी अन्य शब्द से खोजने का प्रयास करें",
        variants: "वेरिएंट",
        stock: "स्टॉक",
        cart: "कार्ट",
        products: "उत्पाद",
        viewCart: "कार्ट देखें",
        backToProducts: "उत्पादों पर वापस",
        yourCart: "आपका कार्ट",
        clear: "हटाएं",
        cartEmpty: "आपका कार्ट खाली है",
        cartEmptyDesc: "कैटलॉग देखें और जो उत्पाद आप ऑर्डर करना चाहते हैं उन्हें जोड़ें।",
        browseProducts: "उत्पाद देखें",
        selectedItems: "चयनित आइटम",
        itemInCart: "आइटम कार्ट में",
        itemsInCart: "आइटम कार्ट में",
        customerDeliveryDetails: "ग्राहक और डिलीवरी विवरण",
        fullName: "पूरा नाम",
        enterFullName: "अपना पूरा नाम दर्ज करें",
        deliveryAddress: "डिलीवरी पता",
        addressPlaceholder: "गली का पता, भवन, शहर, पिन कोड...",
        orderNote: "ऑर्डर नोट (वैकल्पिक)",
        orderNotePlaceholder: "विशेष निर्देश या डिलीवरी नोट...",
        paymentMode: "भुगतान मोड",
        subtotal: "उप-कुल",
        items: "आइटम",
        totalAmount: "कुल राशि",
        orderOnWhatsApp: "WhatsApp पर ऑर्डर करें 📲",
        orderPlaced: "ऑर्डर सफलतापूर्वक दिया गया! 🎉",
        orderPlacedDesc: "आपका ऑर्डर दर्ज हो गया है और WhatsApp खोला गया है।",
        continueShopping: "खरीदारी जारी रखें 🛍️",
        cartEmptyTitle: "कार्ट खाली है",
        cartEmptyToast: "चेकआउट से पहले कृपया अपने कार्ट में उत्पाद जोड़ें।",
        incompleteTitle: "अधूरा विवरण",
        incompleteToast: "ऑर्डर देने से पहले कृपया सभी आवश्यक फ़ील्ड भरें।",
        nameRequired: "पूरा नाम आवश्यक है",
        addressRequired: "डिलीवरी पता आवश्यक है",
        catalogUnavailable: "कैटलॉग वर्तमान में अनुपलब्ध",
        catalogUnavailableDesc: "यह कैटलॉग फिलहाल सक्रिय नहीं है। अधिक जानकारी के लिए व्यवसाय से संपर्क करें।",
        invalidCatalogLink: "अमान्य कैटलॉग लिंक 🚫",
        invalidCatalogDesc: "इस कैटलॉग पेज में आवश्यक जानकारी गायब है।",
        missing: "गायब",
        catalogSlug: "कैटलॉग स्लग",
        goBackHome: "होम पर वापस जाएं",
        inventoryManagement: "इन्वेंटरी प्रबंधन और इनवॉइसिंग 🚀 Simply",
        enter: "दर्ज करें",
        select: "चुनें",
        // Catalog Order translations
        catalogOrders: 'कैटलॉग ऑर्डर',
        pending: 'लंबित',
        converted: 'परिवर्तित',
        cancelled: 'रद्द किया गया',
        totalRevenue: 'कुल मूल्य',
        totalCatalogOrders: 'कुल ऑनलाइन ऑर्डर',
        convertToSalesOrder: 'बिक्री ऑर्डर में बदलें',
        date: 'तारीख',
        status: 'स्थिति',
        action: 'कार्रवाई',
        searchOrders: 'ग्राहक या फोन खोजें...',
        noMatchingOrders: 'कोई मेल खाता ऑर्डर नहीं मिला',
        noStatusOrders: 'कोई {status} ऑर्डर नहीं मिला',
        tryDifferentSearch: 'किसी अन्य ग्राहक नाम या फोन नंबर से खोजने का प्रयास करें.',
        noOrdersWithStatus: 'वर्तमान में {status} स्थिति वाला कोई ऑर्डर नहीं है.',
        noOrdersYet: 'अभी कोई कैटलॉग ऑर्डर नहीं है',
        noOrdersDescription: 'आपके ऑनलाइन कैटलॉग से दिए गए ऑर्डर यहाँ दिखाई देंगे.',
        guestCustomer: 'अतिथि ग्राहक',
        item: 'आइटम',
        moreItems: '+{count} और',
        viewDetails: 'विवरण देखें',
        viewSalesOrder: 'बिक्री ऑर्डर देखें',
        cancelOrder: 'ऑर्डर रद्द करें',
        confirmCancelTitle: 'कैटलॉग ऑर्डर रद्द करें?',
        confirmCancelOrder: 'क्या आप वाकई इस ऑर्डर को रद्द करना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती.',
        keepOrder: 'नहीं, ऑर्डर रखें',
        confirmCancelAction: 'हाँ, ऑर्डर रद्द करें',
        orderNotFound: 'कैटलॉग ऑर्डर नहीं मिला',
        orderNotFoundDescription: 'यह ऑर्डर नहीं मिल सका या आपके पास इसे देखने की अनुमति नहीं हो सकती.',
        backToCatalogOrders: 'कैटलॉग ऑर्डर पर वापस जाएँ',
        placedOn: 'ऑर्डर की तारीख',
        totalItems: 'कुल आइटम',
        orderedProducts: 'ऑर्डर किए गए उत्पाद',
        itemDetails: 'आइटम विवरण',
        quantity: 'मात्रा',
        unitPrice: 'इकाई मूल्य',
        total: 'कुल',
        variant: 'वेरिएंट',
        customerInformation: 'ग्राहक जानकारी',
        additionalFields: 'अतिरिक्त फ़ील्ड',
        fields: 'फ़ील्ड',
    },
    stockNew: {
        Npay: "अभी तक कोई उत्पाद नहीं जोड़ा गया",
        emptydesc: "अपने कैटलॉग से एक उत्पाद चुनें और स्टॉक रिकॉर्ड करने के लिए आने वाली मात्रा दर्ज करें।",
        tipText: "टिप: आप एक्सेल फाइल भी अपलोड कर सकते हैं",
        OT: "ऑर्डर टोटल",
        Collapse: "संकुचित करें"
    },
    deleteBulk: {
        Bulkoperation: "बल्क ऑपरेशन",
        Applyproducts: "एकाधिक उत्पादों पर कार्रवाई लागू करें",
        Bulkupload: "बल्क अपलोड",
        ImportCSVfile: "एक्सेल या CSV फ़ाइल के माध्यम से उत्पाद आयात करें",
        or: "या",
        Bulkdelete: "बल्क डिलीट",
        Permanentlyallproducts: "सभी उत्पादों को स्थायी रूप से हटाएं",
        IrrText: "बल्क डिलीट अपरिवर्तनीय है। जरूरत हो तो पहले बैकअप एक्सपोर्ट करें।",
        SeP: "चयनित उत्पाद",
        sP: "उत्पाद चुनें",
        DA: "सभी हटाएं",
        DP: "उत्पाद हटाएं",
        sL: "सभी चुनें",
        ASDE: "क्या आप वाकई सभी उत्पादों को छोड़कर हटाना चाहते हैं",
        ASDAllP: "क्या आप वाकई सभी उत्पादों को हटाना चाहते हैं?",
        ASD: "क्या आप वाकई हटाना चाहते हैं",
        products: "उत्पाद",
        TACBU: "यह क्रिया पूर्ववत नहीं की जा सकती।",
        LP: "उत्पाद लोड हो रहे हैं...",
        FM: "और लोड हो रहा है...",
        NPF: "कोई उत्पाद नहीं मिला।",
        LMP: "और उत्पाद लोड हो रहे हैं..."
    },
    NewVariantModal: {
        Definevariantsassign: "वैरिएंट परिभाषित करें और मात्रा आवंटित करें",
        Nothingallocated: "कुछ भी आवंटित नहीं",
        Overallocated: "अधिक आवंटित",
        Fullyallocated: "पूर्ण रूप से आवंटित",
        Overby: "अधिक द्वारा",
        Allvariantsneedaname: "सभी वैरिएंट को नाम की आवश्यकता है।",
        Reducequantities: "मात्रा कम करें।",
        Overallocatedby: "अधिक आवंटित द्वारा",
        Quantitiesmustmatchthetotalavailability: "मात्राएँ कुल उपलब्धता से मेल खानी चाहिए।",
        Allocatequantitiesacrosswarehouses: "वेयरहाउस में मात्रा आवंटित करें",
        Notfullydistributed: "पूर्ण रूप से वितरित नहीं:",
        remaining: "शेष",
        Qty: "मात्रा",
        Inactive: "निष्क्रिय",
        left: "बाकी"
    },
    ProductFormNew: {
        BasicInfo: "मूल जानकारी",
        ProductImage: "उत्पाद छवि",
        Images: "छवियाँ",
        Pricing: "मूल्य निर्धारण",
        Everypriceneedsbothalabelandanamount: "हर कीमत के लिए एक लेबल और राशि दोनों की आवश्यकता है",
        AddalabellikeWholesaleorRetailtoidentifythisprice: '"थोक" या "खुदरा" जैसे लेबल जोड़ें इस कीमत को पहचानने के लिए',
        Entertheamountforthisprice: "इस कीमत के लिए राशि दर्ज करें",
        AddMultiplePrice: "एकाधिक मूल्य जोड़ें",
        NoPhotosLetAiFind: "कोई फ़ोटो नहीं? AI को उत्पाद चित्र खोजने दें",
        AddProductImagesTitle: "उत्पाद चित्र जोड़ें",
        ChooseHowToAddPhotos: "चुनें कि आप इस उत्पाद के लिए फ़ोटो कैसे जोड़ना चाहते हैं:",
        SearchWithAi: "AI के साथ खोजें",
        SearchWithAiDesc: "AI का उपयोग करके स्वचालित रूप से उत्पाद चित्र खोजें और चुनें",
        FilesFileExplorer: "फ़ाइलें (फ़ाइल एक्सप्लोरर)",
        FilesFileExplorerDesc: "सीधे अपने कंप्यूटर से चित्र चुनें",
        AiProductImageFinder: "AI उत्पाद छवि खोजक",
        AiProductImageFinderDesc: "अपने उत्पाद के लिए चित्र खोजें और चुनें",
        TypeProductNamePlaceholder: "उत्पाद का नाम टाइप करें...",
        SearchForYourProduct: "अपने उत्पाद की खोज करें",
        SearchForYourProductHint: `ब्रांड या उत्पाद का नाम आज़माएं, जैसे "किर्कलैंड मिनॉक्सिडिल"`,
        ImagesSelected: "चित्र चुने गए",
        AddSelected: "चयनित जोड़ें"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "नया कस्टम फ़ील्ड परिभाषित करें",
        AttributeName: "एTRIBUTE का नाम",
        DataType: "डेटा प्रकार",
        Noattributesfound: "कोई एTRIBUTE नहीं मिला",
        ManageAttributes: "एTRIBUTE प्रबंधित करें",
        Editordeleteexistingattributes: "मौजूदा एTRIBUTE संपादित करें या हटाएं",
        UpdateAttribute: "एTRIBUTE अपडेट करें",
        Saving: "सहेजा जा रहा है..."
    },
    NewExpenses: {
        Noexpensesyet: "अभी तक कोई खर्च नहीं",
        Addyourfirstexpensetostarttrackingyourspending: "अपना पहला खर्च जोड़ें और अपने खर्च को ट्रैक करना शुरू करें।",
        TOTALEXPENSES: "कुल खर्च",
        ENTRIES: "एंट्री",
        BYCATEGORY: "श्रेणी के अनुसार",
        Nocategoriestodisplay: "दिखाने के लिए कोई श्रेणी नहीं",
        DateanfTime: "तारीख और समय"
    },
    PurchaseSales: {
        CancelOrder: "ऑर्डर रद्द करें",
        ReopenOrder: "ऑर्डर पुनः खोलें",
        Reopen: "पुनः खोलें",
        ConfirmCancelOrder: "क्या आप वाकई इस ऑर्डर को रद्द करना चाहते हैं?",
        ConfirmReopenOrder: "क्या आप वाकई इस ऑर्डर को पुनः खोलना चाहते हैं?",
        OrderCancelledSuccessfully: "ऑर्डर सफलतापूर्वक रद्द किया गया।",
        OrderReopenedSuccessfully: "ऑर्डर सफलतापूर्वक पुनः खोला गया।",
        CancelledBy: "द्वारा रद्द किया गया",
        Cancelled: "रद्द",
        ConvertPriceBasedOnUnitConversion: "इकाई रूपांतरण के आधार पर मूल्य रूपांतरित करें",
        MarkPaymentAsPending: "भुगतान को लंबित के रूप में चिह्नित करें",
        PendingReceivableDesc: "राशि प्राप्य के रूप में दर्ज। भुगतान प्राप्त होने पर दर्ज करें।",
        PendingPayableDesc: "राशि देय के रूप में दर्ज। भुगतान करने पर दर्ज करें।",
        SelectCustomerFirst: "पहले ग्राहक चुनें",
        SelectSupplierFirst: "पहले आपूर्तिकर्ता चुनें",
        SelectItemsFirst: "कृपया पहले कम से कम एक आइटम चुनें",
        PaymentMarkedPendingDesc: "भुगतान को लंबित चिह्नित किया गया है। अभी भुगतान दर्ज करने के लिए 'भुगतान को लंबित के रूप में चिह्नित करें' अनचेक करें।",
        SelectCustomerAndItemFirst: "कृपया पहले ग्राहक और कम से कम एक आइटम चुनें",
        SelectSupplierAndItemFirst: "कृपया पहले आपूर्तिकर्ता और कम से कम एक आइटम चुनें",
        SelectCustomerProductFirst: "पहले ग्राहक और उत्पाद चुनें",
        SelectSupplierProductFirst: "पहले आपूर्तिकर्ता और उत्पाद चुनें",
        Receivables: "प्राप्य",
        Payables: "देय",
        AccessDenied: "प्रवेश निषेध",
        YouDonthaeP: "इस पेज को देखने की आपको अनुमति नहीं है। यदि आपको लगता है कि यह गलती है, तो कृपया अपने व्यवस्थापक से संपर्क करें।",
        purchase: "खरीद",
        sales: "बिक्री",
        Areyousureyouwantto: "क्या आप वाकई चाहते हैं कि",
        Thisactionwillupdateitsstatus: "यह क्रिया इसकी स्थिति अपडेट करेगी।",
        ReasonOPtional: "कारण (वैकल्पिक)",
        Enterareasonfor: "के लिए कारण दर्ज करें",
        optionalDot: "(वैकल्पिक)...",
        Reject: "अस्वीकार करें",
        ConfirmOrder: "ऑर्डर की पुष्टि करें",
        RejectOrder: "ऑर्डर अस्वीकार करें",
        Previous: "पिछला",
        First: "पहला",
        Order: "ऑर्डर",
        Items: "आइटम",
        Memo: "मेमो",
        SelectDateRange: "तारीख सीमा चुनें",
        List: "सूची",
        Board: "बोर्ड",
        View: "देखें",
        CreateSalesOrder: "बिक्री ऑर्डर बनाएं",
        CreatePurchaseOrder: "खरीद ऑर्डर बनाएं",
        successfully: "सफलतापूर्वक",
        ManageAttachments: "संलग्नक प्रबंधित करें",
        Stockoutitemsimmediatelyaftersaving: "सहेजने के तुरंत बाद आइटम स्टॉक आउट करें।",
        Stockinitemsimmediatelyaftersavingthisorder: "इस ऑर्डर को सहेजने के तुरंत बाद आइटम स्टॉक इन करें।",
        ViewAttachments: "संलग्नक देखें",
        MemoAttachments: "मेमो और संलग्नक",
        ReceivedDate: "प्राप्ति तिथि",
        ShippedDate: "शिपमेंट तिथि",
        OrderDate: "ऑर्डर तिथि",
        OrderDetails: "ऑर्डर विवरण",
        Subtotal: "उप-कुल",
        OrderSummary: "ऑर्डर सारांश",
        AddItem: "आइटम जोड़ें",
        NewSalesOrder: "नया बिक्री ऑर्डर",
        NewPurchaseOrder: "नया खरीद ऑर्डर",
        Createandmanageyour: "बनाएं और प्रबंधित करें आपके",
        orders: "ऑर्डर",
        Removeitem: "आइटम हटाएं",
        UnitPrice: "इकाई मूल्य",
        PurchaseOrder: "खरीद ऑर्डर",
        SalesOrder: "बिक्री ऑर्डर",
        PurchaseInvoice: "खरीद इनवॉइस",
        SalesInvoice: "बिक्री इनवॉइस",
        PurchaseOrdernotfound: "खरीद ऑर्डर नहीं मिला",
        Approve: "अनुमोदन करें",
        MarkasShipped: "शिप्ड के रूप में चिह्नित करें",
        MarkasReceived: "प्राप्त के रूप में चिह्नित करें",
        Marking: "चिह्नित हो रहा है...",
        PartiallyShip: "आंशिक शिप",
        PartiallyReceive: "आंशिक प्राप्ति",
        Deleting: "हटा रहा है...",
        Transaction: "लेन-देन",
        Details: "विवरण",
        Item: "आइटम",
        Received: "प्राप्त",
        Shipped: "शिप्ड",
        Ordered: "ऑर्डर किया गया",
        units: "इकाइयाँ",
        Overalldiscount: "कुल छूट",
        Transactions: "लेन-देन",
        Notransactionsfound: "कोई लेन-देन नहीं मिला",
        OrderedQty: "ऑर्डर की गई मात्रा",
        Totalqty: "कुल मात्रा",
        StockingOut: "स्टॉक आउट हो रहा है...",
        StockingIn: "स्टॉक इन हो रहा है...",
        thiorderUpdateStuau: "यह ऑर्डर? यह क्रिया इसकी स्थिति अपडेट करेगी।",
        TransactionDetails: "लेन-देन विवरण",
        Fetchingtransactiondetails: "लेन-देन विवरण ला रहा है...",
        Nodetailsfoundforthistransaction: "इस लेन-देन के लिए कोई विवरण नहीं मिला।",
        TotalBreakDown: "कुल ब्रेकडाउन",
        ChangeAmount: "परिवर्तन राशि",
        Attachments: "संलग्नक",
        PoNumber: "पी.ओ. नंबर",
        SoNumber: "एस.ओ. नंबर",
        partner: "पार्टनर",
        EditPurchase: "खरीद संपादित करें",
        EditSales: "बिक्री संपादित करें",
        PurchaseOrderDetails: "खरीद ऑर्डर विवरण",
        SalesOrderDetails: "बिक्री ऑर्डर विवरण",
        OrderType: "ऑर्डर का प्रकार",
        SelectOrderType: "ऑर्डर का प्रकार चुनें",
        OrderTypePrepaid: "प्रीपेड",
        OrderTypeCOD: "कैश ऑन डिलीवरी",
        OrderTypePayLater: "बाद में भुगतान करें",
        OrderTypePartialPayment: "आंशिक भुगतान",
        OrderTypeSubscription: "सदस्यता",
        viewAvailabilty: "उपलब्धता देखें",
        NotReceived: "प्राप्त नहीं हुआ",
        NotShipped: "शिप नहीं हुआ",
        PartiallyReceived: "आंशिक रूप से प्राप्त",
        PartiallyShipped: "आंशिक रूप से शिप किया गया",
    },
    PriceReference: {
        HighPrice: "उच्च मूल्य",
        LowPrice: "निम्न मूल्य",
        LastPrice: "अंतिम मूल्य",
        LastPurchasePrice: "अंतिम खरीद मूल्य",
        Nopricerecordsfound: "कोई मूल्य रिकॉर्ड नहीं मिला",
        BuyingPriceReference: "खरीद मूल्य संदर्भ",
        SellingPriceReference: "बिक्री मूल्य संदर्भ",
        Viewstockinpricesfortheselectedvendorandproduct: "चयनित विक्रेता और उत्पाद के लिए स्टॉक-इन मूल्य देखें",
        Viewstockoutpricesfortheselectedcustomerandproduct: "चयनित ग्राहक और उत्पाद के लिए स्टॉक-आउट मूल्य देखें"
    },
    SubscriptionLocale: {
        premiumPlan: "प्रीमियम प्लान",
        heading: "व्यवसायिक निर्णय लें",
        headingHighlight: "डेटा के आधार पर",
        subtitle: "अपने बिजनेस एनालिटिक्स की पूरी शक्ति अनलॉक करें — कोई सीमा नहीं, कोई समझौता नहीं।",
        choosePlan: "अपना प्लान चुनें",
        monthly: "मासिक",
        annual: "वार्षिक",
        oneTime: "एक बार (माह)",
        perMonth: "प्रति माह",
        perYear: "प्रति वर्ष",
        bestValue: "सर्वश्रेष्ठ मूल्य",
        continueWith: "के साथ जारी रखें",
        perMonthShort: "माह",
        perYearShort: "वर्ष",
        troubleWithSubscription: "सब्सक्रिप्शन में समस्या?",
        contactUs: "संपर्क करें",
        paymentNotReady: "भुगतान तैयार नहीं",
        checkoutError: "चेकआउट त्रुटि",
        pricePreviewError: "मूल्य पूर्वावलोकन त्रुटि",
        subNotAvailable: "सदस्यता उपलब्ध नहीं है",
        subNotAvailableDesc: "वेब सदस्यता वर्तमान में आपके देश में उपलब्ध नहीं है। कृपया हमारे मोबाइल ऐप के माध्यम से सदस्यता लें या सहायता के लिए हमसे संपर्क करें।"
    },
    SubscriptionLocale2: {
        GoPro: "प्रो पर जाएं",
        Makesmarterdecisionsbackedbyrealbusinessdata: "वास्तविक बिजनेस डेटा द्वारा समर्थित स्मार्टर निर्णय लें",
        ExploreProPlans: "प्रो प्लान्स एक्सप्लोर करें"
    },
    emptyWarehouseState: {
        tips: [
            "आप विभिन्न भौतिक स्थानों के लिए एकाधिक गोदाम रख सकते हैं",
            "प्रत्येक उत्पाद गोदाम अनुसार स्टॉक को स्वतंत्र रूप से ट्रैक करता है",
            '"वेयरहाउस ट्रांसफर" का उपयोग करके स्टॉक को एक स्थान से दूसरे स्थान पर स्थानांतरित करें'
        ],
        NoWarehousesConfigured: "कोई वेयरहाउस कॉन्फ़िगर नहीं किया गया",
        desc: "सबसे पहले अपने वेयरहाउस जोड़ें (अगर आपके पास एक से अधिक हैं), फिर उत्पाद जोड़ें और स्टॉक मूवमेंट रिकॉर्ड करें।",
        WarehouseSetupTips: "वेयरहाउस सेटअप टिप्स",
        Noproductselected: "कोई उत्पाद चयनित नहीं",
        Selectaproductfromthelefttoviewlowstockdetails: "निम्न स्टॉक विवरण देखने के लिए बाईं ओर से एक उत्पाद चुनें।",
        Chooseaproductfromthelist: "सूची से एक उत्पाद चुनें",
        SelectProduct: "उत्पाद चुनें",
        SetQuantity: "मात्रा सेट करें",
        Showing: "दिखाया जा रहा है",
        products: "उत्पाद",
        Continue: "जारी रखें",
        SaveSafetyStock: "सेफ्टी स्टॉक सहेजें",
        SafetyStockSaved: "सेफ्टी स्टॉक सहेज लिया गया!",
        hasbeensetto: "को सेट कर दिया गया है",
        AddAnother: "एक और जोड़ें",
        Chooseaproduct: "एक उत्पाद चुनें",
        Step: "चरण",
        of: "का",
        Setsafetyquantity: "सेफ्टी मात्रा सेट करें",
        Complete: "पूर्ण",
        SafetyStockQuantity: "सेफ्टी स्टॉक मात्रा",
        Minimumunitsdropsbelowthisnumber: "स्टॉक में हमेशा रखने के लिए न्यूनतम यूनिट्स। जब स्टॉक इस संख्या से नीचे गिरता है तो अलर्ट ट्रिगर होता है।",
        NewSafetyStock: "नया सेफ्टी स्टॉक",
        SafetyNow: "सेफ्टी अब",
        SettingTo: "सेट किया जा रहा है",
        Change: "बदलें",
        sell: "बेचना",
        cost: "लागत",
        BulUD: "बल्क अपलोड/डिलीट"
    },
    SimplyLoginUI: {
        sslEncryption: "256-बिट SSL एन्क्रिप्शन",
        dataPrivate: "आपका डेटा 100% निजी है",
        worksOnDevices: "Android और iPhone पर काम करता है",
        realTimeSync: "सभी डिवाइस पर रीयल-टाइम सिंक",
        cloudBackup: "स्वचालित क्लाउड बैकअप",
        availableOn: "वेब, Android और iOS पर उपलब्ध",
        tagline: "आपका इन्वेंटरी,",
        taglineEm: "खूबसूरती से सरल।",
        subtitle: "स्टॉक मैनेज करने, बिक्री ट्रैक करने और अपना बिजनेस आगे बढ़ाने के लिए साइन इन करें — सब कुछ एक जगह।",
        feature1Title: "रीयल-टाइम स्टॉक ट्रैकिंग",
        feature1Desc: "हर वेयरहाउस में क्या है, ठीक-ठीक जानें — हमेशा अपडेट।",
        feature2Title: "बिक्री और खरीद ऑर्डर",
        feature2Desc: "इनवॉइस बनाएं, वेंडर मैनेज करें और हर ट्रांजेक्शन ट्रैक करें।",
        feature3Title: "स्मार्ट रिपोर्ट्स",
        feature3Desc: "फाइनेंस, स्टॉक और डेली मूवमेंट रिपोर्ट्स एक नजर में।",
        feature4Title: "सभी डिवाइस पर रीयल-टाइम सिंक",
        feature4Desc: "फोन पर बदलाव वेब पर तुरंत दिखते हैं — और vice versa।",
        rating1: "रेटेड",
        rating2: "4.9/5",
        rating3: "10,000 थोक व्यवसायों द्वारा",
        brandName: "Simply",
        greeting: "फिर से हेलो! 👋",
        noPasswordNeeded: "अपने इन्वेंटरी एक्सेस करने के लिए साइन इन करें — Android, iPhone और वेब, सब सिंक में।",
        badge1: "स्टॉक मैनेजमेंट",
        badge2: "सेल्स ट्रैकिंग",
        badge3: "रिपोर्ट्स",
        trustEncryptedTitle: "एन्क्रिप्टेड",
        trustEncryptedSub: "256-बिट SSL",
        trustPrivateTitle: "प्राइवेट",
        trustPrivateSub: "सिर्फ आपका डेटा",
        trustBackedTitle: "बैकअप",
        trustBackedSub: "रोज ऑटो",
        availableOnLabel: "उपलब्ध है",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "वेब",
        syncBadge: "सभी डिवाइस रीयल-टाइम में तुरंत सिंक होते हैं",
        securityNote: "100% सुरक्षित।",
        securityDesc: "बैंक-ग्रेड एन्क्रिप्शन आपके सभी डेटा की सुरक्षा करता है। हम सिर्फ आपका नाम और ईमेल पढ़ते हैं — कुछ और नहीं, कभी नहीं।",
        signingIn: "साइन इन हो रहा है…",
        termsPrefix: "साइन इन करके आप Simply की",
        privacyPolicy: "प्राइवेसी पॉलिसी",
        and: "और",
        termsOfService: "सेवा की शर्तें",
        google: "Google से लॉगिन करें"
    },
    BatchLocal: {
        BatchName: "बैच का नाम",
        EnterBatchName: "बैच का नाम दर्ज करें",
        EnterNotes: "नोट्स दर्ज करें",
        ExpiredDate: "समाप्ति तिथि",
        Selectexpireddate: "समाप्ति तिथि चुनें",
        BatchStatus: "बैच की स्थिति",
        CreatedDate: "निर्माण तिथि",
        Areyousureyouwanttodeletethisbatch: "क्या आप वाकई इस बैच को हटाना चाहते हैं?",
        Youhavencreatedanybatchforthisproduct: "आपने इस उत्पाद के लिए अभी तक कोई बैच नहीं बनाया है।",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "पहला बैच बनाएं ताकि लॉट और समाप्ति तिथि के अनुसार स्टॉक ट्रैक करना शुरू कर सकें।",
        Nobatchesyet: "अभी तक कोई बैच नहीं है",
        Whatisbatchmanagement: "बैच मैनेजमेंट क्या है?",
        Howithelpsyourbusiness: "यह आपके व्यवसाय की कैसे मदद करता है",
        Trackbylotnumber: "लॉट नंबर के अनुसार ट्रैक करें",
        Trackbylotnumberdesc: "मैन्युफैक्चरर बैच के अनुसार स्टॉक को ग्रुप करें ताकि आपको हमेशा पता रहे कि कौन से लॉट से यूनिट आई है।",
        Expirydatecontrol: "समाप्ति तिथि नियंत्रण",
        Expirydatecontroldesc: "स्टॉक समाप्त होने से पहले अलर्ट प्राप्त करें। पुरानी बैच पहले बेचें और अपव्यय स्वचालित रूप से कम करें।",
        Fulltraceability: "पूर्ण ट्रेसेबिलिटी",
        Fulltraceabilitydesc: "हर लेन-देन में कौन सी बैच इस्तेमाल हुई, ठीक-ठीक देखें — ऑडिट और रिकॉल के लिए बहुत उपयोगी।",
        Supplierwisestock: "सप्लायर के अनुसार स्टॉक",
        Supplierwisestockdesc: "एक ही उत्पाद के लिए भी अलग-अलग सप्लायर का स्टॉक अलग रखें। बैच दर बैच क्वालिटी की तुलना करें।",
        Createyourfirstbatchbutton: "अपनी पहली बैच बनाएं",
        Nomatchesfound: "कोई मैच नहीं मिला",
        NomatchesfounddescBefore: "हम ",
        NomatchesfounddescAfter: " से मेल खाती कोई बैच नहीं ढूंढ पाए।",
        Clearsearch: "सर्च साफ करें",
        Nohistoryfoundthisbatch: "इस बैच के लिए कोई इतिहास नहीं मिला",
        ComprehensiveDetails: "व्यापक विवरण",
        History: "इतिहास",
        InBatch: "बैच में",
        Noproductfoundinthisbatch: "इस बैच में कोई उत्पाद नहीं मिला",
        SelectBatch: "बैच चुनें",
        available: "उपलब्ध",
        Searchbatches: "बैच खोजें...",
        Expires: "समाप्त होता है",
        Nobatchesfound: "कोई बैच नहीं मिला",
        ManageBatches: "बैच प्रबंधित करें",
        Batchmanagement: "बैच मैनेजमेंट",
        Trackstockexpiry: "बैच और समाप्ति तिथि के अनुसार स्टॉक ट्रैक करें",
        Turnoffbatchmanagement: "बैच मैनेजमेंट बंद करें?",
        Yourgsafe: "आपका मौजूदा बैच डेटा सुरक्षित रहेगा।",
        Reenableanytimefrom: "किसी भी समय पुनः सक्षम करें",
        Otherstab: "अन्य टैब से",
        AddBatch: "बैच जोड़ें",
        Total: "कुल",
        AssignProduct: "उत्पाद असाइन करें",
        EditProductAssignment: "उत्पाद असाइनमेंट संपादित करें",
        AssignProducttoBatch: "उत्पाद को बैच में असाइन करें",
        Updateproductconfiguration: "उत्पाद कॉन्फ़िगरेशन अपडेट करें",
        Step1of2: "चरण 1 का 2",
        Step2of2: "चरण 2 का 2",
        Selectvariantwarehouse: "वैरिएंट और वेयरहाउस चुनें",
        SelectedProduct: "चयनित उत्पाद",
        AssignQuantity: "मात्रा असाइन करें",
        BatchInfo: "बैच की जानकारी",
        Wecouldnthisproductidentifier: "हम इस उत्पाद पहचानकर्ता से जुड़ी कोई बैच नहीं ढूंढ पाए।",
        NoActiveBatches: "कोई सक्रिय बैच नहीं",
        Endofresults: "परिणामों का अंत",
        Expiry: "समाप्ति",
        BatchManagementDescription: "बैच नंबर और समाप्ति तिथि के अनुसार स्टॉक ट्रैक करें। हर स्टॉक-आउट पर सही LIFO / FEFO क्रम सुनिश्चित करता है — किसी मैन्युअल चयन की आवश्यकता नहीं है।",
        Expiryalerts: "समाप्ति अलर्ट",
        Autonotifications: "स्वचालित सूचनाएं",
        LIFOsorting: "LIFO / FEFO सॉर्टिंग",
        Smartstockflow: "स्मार्ट स्टॉक फ्लो",
        Perout: "प्रति-बैच स्टॉक-आउट",
        Precisiontracking: "सटीक ट्रैकिंग",
        NeedsReview: "समीक्षा आवश्यक",
        Pending: "लंबित",
        Rejected: "अस्वीकृत",
        Approved: "स्वीकृत",
        WaitingForApproval: "अनुमोदन की प्रतीक्षा",
        WaitingForApprovalDesc: "आपका मालिक जल्द ही इस बैच की समीक्षा और अनुमोदन करेगा।",
        BatchRejected: "बैच अस्वीकृत",
        BatchRejectedDesc: "आपके मालिक ने इस बैच को अस्वीकार कर दिया।",
        Reason: "कारण",
        Approve: "स्वीकृत करें",
        Reject: "अस्वीकार करें",
        ConfirmApproveTitle: "बैच स्वीकृत करें",
        ConfirmRejectTitle: "बैच अस्वीकार करें",
        ConfirmApprovalAction: "क्या आप सुनिश्चित हैं कि आप इस बैच को {action} करना चाहते हैं? यह कार्रवाई इसकी स्थिति अपडेट करेगी।",
        ReasonOptional: "कारण (वैकल्पिक)",
        EnterReasonPlaceholder: "{action} के लिए कारण दर्ज करें (वैकल्पिक)",
        Processing: "प्रसंस्करण हो रहा है...",
        BatchActivatedSuccess: "बैच सफलतापूर्वक सक्रिय किया गया",
        BatchDeactivatedSuccess: "बैच सफलतापूर्वक निष्क्रिय किया गया",
        BatchDeletedSuccess: "बैच सफलतापूर्वक हटाया गया",
        BatchApprovedSuccess: "बैच सफलतापूर्वक स्वीकृत किया गया",
        BatchRejectedSuccess: "बैच सफलतापूर्वक अस्वीकृत किया गया",
        SearchByBatchName: "बैच नाम से खोजें...",
        YesTurnOff: "हाँ, बंद करें",
        KeepItOn: "इसे चालू रखें"
    },
    CategoryNewL: {
        TotalCategories: "कुल श्रेणियाँ",
        lastaddedcategory: "अंतिम जोड़ी गई श्रेणी",
        acrossalltypes: "सभी प्रकारों में",
        MostRecent: "सबसे हालिया",
        YesD: "हाँ, हटाएँ",
        AllAssociated: "सभी संबंधित उत्पाद प्रभावित हो सकते हैं"
    },
    OverDas: {

        movestockbetweenlocations: "स्टॉक स्थानांतरित करें",
        no_activity_yet: "अभी तक कोई गतिविधि नहीं",
        no_activity_sub: "बिक्री, खरीद, स्टॉक मूवमेंट और रिटर्न यहां रीयल टाइम में दिखेंगे।",
        make_first_sale: "पहली बिक्री करें",
        add_stock: "स्टॉक जोड़ें",
        all_stock_healthy: "सभी स्टॉक स्तर स्वस्थ हैं",
        all_stock_healthy_sub: "कोई आइटम कम नहीं पड़ रहा है। यहां अलर्ट पाने के लिए प्रोडक्ट पर न्यूनतम सीमा सेट करें।",
        set_stock_thresholds: "स्टॉक थ्रेशोल्ड सेट करें",
        no_warehouses_setup: "कोई वेयरहाउस सेटअप नहीं किया गया",
        no_warehouses_setup_sub: "अपना स्टॉक कहां स्टोर है उसे ट्रैक करने और लोकेशन मैनेज करने के लिए एक वेयरहाउस जोड़ें।",
        add_first_warehouse: "पहला वेयरहाउस जोड़ें",
        Customer: "ग्राहक",
        PurchasevsSales: "खरीद बनाम बिक्री",
        Financialperformancechart: "वित्तीय प्रदर्शन चार्ट",
        QuickActions: "त्वरित कार्रवाई",
        Frequentlyused: "बार-बार इस्तेमाल होने वाले",
        Addinventory: "इन्वेंटरी जोड़ें",
        Dispatchitems: "आइटम डिस्पैच करें",
        Addorder: "ऑर्डर जोड़ें",
        Newitem: "नई आइटम",
        Inventoryaccess: "इन्वेंटरी एक्सेस",
        Itemsneedingreorder: "रीऑर्डर की जरूरत वाले आइटम",
        Latesttransactions: "नवीनतम लेन-देन",
        Operationalsummary: "ऑपरेशनल सारांश",
        ViewAll: "सभी देखें",
        Manage: "मैनेज करें",
        RecentActivity: "हाल की गतिविधि",
        LowStockAlerts: "कम स्टॉक अलर्ट",
        Primary: "प्राथमिक",
        TotalWarehouses: "कुल वेयरहाउस"
    },
    SerialLocal: {
        ShowOrHideFields: "फ़ील्ड दिखाएं या छिपाएं",
        ShowOrHideFieldsDesc: "मुद्रित चालान में इसे शामिल करने या हटाने के लिए नीचे दिए गए किसी भी आइटम पर टैप करें। परिवर्तन तुरंत लागू होते हैं।",
        Manufacturesettings: "विनिर्माण सेटिंग्स",
        Showbuyingprice: "क्रय मूल्य / उत्पाद लागत",
        Showadditionalcost: "अतिरिक्त लागत",
        Costbreakdown: "लागत विवरण",
        Unitcost: "इकाई लागत",
        Rawmaterialstotal: "कुल कच्चा माल",
        Confirmentry: "एंट्री कन्फर्म करें",
        SaveSerials: "सीरियल नंबर सेव करें",
        SerialNumber: "सीरियल नंबर",
        selected: "चयनित",
        added: "जोड़ा गया",
        Serialnumbers: "सीरियल नंबर",
        ResetAll: "सभी रीसेट करें",
        Wecouldnfindthis: "इस प्रोडक्ट के लिए कोई उपलब्ध सीरियल नंबर नहीं मिला।",
        Nounitsfound: "कोई यूनिट नहीं मिली",
        Searchingserialnumbers: "सीरियल नंबर खोज रहे हैं...",
        Scanorenterstock: "नए स्टॉक के लिए सीरियल स्कैन करें या दर्ज करें",
        Whataserialnumber: "सीरियल नंबर क्या है?",
        Auniqueidentifieryourinventorylifecycle: "प्रत्येक यूनिट के लिए एक अनोखा पहचानकर्ता — यह आपको पूरे इन्वेंट्री लाइफसाइकिल में हर आइटम को ट्रैक करने की सुविधा देता है।",
        Trackedstockout: "ट्रैक किया गया स्टॉक आउट",
        Chooseexactlyselected: "चुनें कि ठीक-ठीक कौन से सीरियल नंबर बाहर जा रहे हैं। केवल इस प्रोडक्ट के लिए स्टॉक किए गए सीरियल ही दिखाए जाते हैं — एक बार चुनने के बाद मात्रा लॉक हो जाती है ",
        SelectSerialstoout: " - बाहर भेजने के लिए सीरियल चुनें",
        Thisinvoicegeneratedusingwwwsimplstockco: "यह इनवॉइस www.simplstock.co का उपयोग करके तैयार किया गया है",
        AuthorizedSignature: "अधिकृत हस्ताक्षर",
        Invoicesettings: "इनवॉइस सेटings",
        Draw: "ड्रा करें",
        Taptoselectordeselectitems: "आइटम चुनने या हटाने के लिए टैप करें",
        Thissignaturewillbeadded: "यह हस्ताक्षर आपकी प्रिंटेड इनवॉइस के नीचे जोड़ा जाएगा।",
        SignatureOptions: "हस्ताक्षर विकल्प",
        Upload: "अपलोड",
        DrawSignature: "हस्ताक्षर ड्रा करें",
        UploadSignature: "हस्ताक्षर अपलोड करें",
        Clear: "साफ करें",
        ShowStaffName: "स्टाफ का नाम",
        ShowSKU: "SKU",
        ShowBusinessName: "बिजनेस का नाम",
        ShowProductName: "प्रोडक्ट का नाम",
        ShowBusinessPhoneNumber: "फोन नंबर",
        ShowBusinessEmail: "ईमेल",
        ShowBusinessAddress: "पता",
        ShowProductImage: "उत्पाद की छवि",
        ShowPaymentDetails: "भुगतान विवरण",
        ShowCategory: "कैटेगरी",
        ShowVariant: "वैरिएंट",
        ShowWarehouse: "वेयरहाउस",
        ShowAttributes: "एट्रिब्यूट्स",
        ShowQuantity: "मात्रा",
        ShowDiscount: "डिस्काउंट",
        ShowTax: "टैक्स",
        ShowPrice: "कीमत",
        ShowTotalPrice: "उत्पाद की कुल कीमत",
        ShowExpenses: "खर्च",
        ShowSignature: "हस्ताक्षर",
        ShowNote: "नोट",
        ShowSerialNumber: "सीरियल नंबर",
        Invoicesettingsapplied: "इनवॉइस सेटिंग्स लागू की गईं। बदलाव के लिए इनवॉیس चेक करें।",
        EnterSerialNumber: "सीरियल नंबर दर्ज करें",
        showAttachment: "अटैचमेंट"
    },
    FewLocal: {
        SelectBin: "बिन चुनें",
        Live: "लाइव",
        Monitorinventorystocklevels: "इन्वेंट्री, मूवमेंट और स्टॉक लेवल की निगरानी करें",
        StockControlCentre: "स्टॉक कंट्रोल सेंटर",
        Nochartdataavailable: "कोई चार्ट डेटा उपलब्ध नहीं",
        Disabled: "अक्षम",
        Enabled: "सक्षम"
    },
    Bin: {
        Bin: "बिन",
        Add: "जोड़ें",
        NoBinsAddedYet: "अभी तक कोई बिन नहीं जोड़ा गया",
        BinLocationsHelp: "बिन लोकेशन आपको इस वेयरहाउस के अंदर सटीक जगह पर स्टॉक ट्रैक करने में मदद करते हैं — अब खोजने की जरूरत नहीं।",
        NameThemByPosition: "स्थान के अनुसार नाम दें:",
        AddBinLocation: "बिन लोकेशन जोड़ें",
        BinLocations: "बिन लोकेशन",
        BinNameRequired: "बिन का नाम आवश्यक है",
        EditBin: "बिन संपादित करें",
        AddBin: "बिन जोड़ें",
        EnterBinName: "बिन का नाम",
        EnterBinNamePlaceholder: "बिन का नाम दर्ज करें",
        BinStatus: "बिन की स्थिति",
        BinNotes: "नोट्स",
        EnterBinNotesPlaceholder: "कुछ नोट्स जोड़ें...",
        ViewInventory: "इन्वेंटरी देखें",
        Inventory: "इन्वेंटरी",
        TrymatchingadifferentSKUname: "कोई दूसरा SKU या नाम आजमाएं।",
        Thisbinlocationcurrentlyempty: "यह बिन लोकेशन फिलहाल खाली है।",
        Loadingbins: "बिन लोड हो रहे हैं...",
        bins: "बिन",
        ManageBin: "बिन प्रबंधित करें",
        Print: "प्रिंट",
        SBin: "सोर्स बिन",
        DBin: "डेस्टिनेशन बिन"
    },
    WarehouseExcel: {
        title: "वेयरहाउस और बिन लोकेशन अपलोड करें",
        description: "नीचे दिए स्टेप्स का पालन करके Excel फाइल से बल्क में वेयरहाउस और उनके बिन लोकेशन बनाएं।",
        bulkUploadGuide: "बल्क अपलोड गाइड",
        step1: "स्टेप 1",
        downloadTemplate: "Excel टेम्प्लेट डाउनलोड करें",
        downloadTemplateDesc: "सभी जरूरी कॉलम हेडर के साथ ऑफिशियल टेम्प्लेट डाउनलोड करें। किसी भी कॉलम का नाम बदलें या हटाएं नहीं।",
        downloadTemplateBtn: "टेम्प्लेट डाउनलोड करें",
        step2: "स्टेप 2",
        fillExcelFile: "Excel फाइल भरें",
        fillExcelDesc: "हर रो एक वेयरहाउस का प्रतिनिधित्व करती है। सभी कॉलम भरें — बिन लोकेशन के लिए <code>Bin Names</code> कॉलम में सभी बिन नाम कोमा से अलग करके लिखें।",
        step3: "स्टेप 3",
        thingsToKeepInMind: "ध्यान रखने योग्य बातें",
        rulesDesc: "अपलोड करने से पहले सुनिश्चित करें कि आपकी फाइल इन नियमों का पालन करती है।",
        step4: "स्टेप 4",
        uploadYourFile: "अपनी फाइल अपलोड करें",
        uploadDesc: "भरने के बाद नीचे फाइल अपलोड करें। सिस्टम स्वचालित रूप से सभी वेयरहाउस और बिन लोकेशन बना देगा।",
        rules: ["प्रति वेयरहाउस केवल एक रो", "एक सेल में कोमा से अलग बिन नाम", "कॉलम हेडर का नाम न बदलें", "एक वेयरहाउस में डुप्लिकेट बिन नाम छोड़ दिए जाते हैं", "देश कोड सहित फोन नंबर", "केवल .xlsx या .xls फाइलें स्वीकार्य"],
        dropFileHere: "अपनी Excel फाइल यहां ड्रॉप करें",
        supports: "सपोर्ट करता है .xlsx और .xls — अधिकतम 10 MB",
        chooseFileUpload: "फाइल चुनें और अपलोड करें",
        parsing: "फाइल पार्स की जा रही है...",
        invalidFileType: "अमान्य फाइल प्रकार। कृपया Excel फाइल अपलोड करें।",
        noData: "Excel में कोई डेटा नहीं मिला",
        failedToRead: "Excel फाइल पढ़ने में विफल",
        unableToRead: "फाइल पढ़ने में असमर्थ।",
        reviewTitle: "वेयरहाउस डेटा की समीक्षा",
        reviewSubtitle: "आपके बिजनेस में आयात करने से पहले अंतिम जांच।",
        changeFile: "फाइल बदलें",
        rowsFound: "रो मिली",
        cancel: "रद्द करें",
        finalizeImport: "फाइनल करें और आयात करें",
        importing: "आयात हो रहा है...",
        success: "सफल",
        allWarehouseUploadedSuccess: "सभी वेयरहाउस सफलतापूर्वक अपलोड हो गए",
        failed: "विफल",
        bulkUploadFailed: "बल्क अपलोड विफल",
        error: "त्रुटि",
        binNamesNote: "<strong>Bin Names</strong> कॉलम में एक ही सेल में सभी बिन लोकेशन कोमा से अलग करके लिखें — उदाहरण: A1, A2, B1, RACK-01।",
        headers: { warehouseName: "वेयरहाउस का नाम", email: "ईमेल", phoneNumber: "फोन नंबर", location: "स्थान", binNames: "बिन नाम" }
    },
    VariantTemplate: {
        VariantTemplates: "वैरिएंट टेम्प्लेट्स",
        Managereusablevariantpatterns: "रीयूजेबल वैरिएंट पैटर्न्स मैनेज करें",
        BinTransferHistory: "बिन ट्रांसफर हिस्ट्री",
        Trackmovementsacrossbins: "बिन्स के बीच मूवमेंट्स ट्रैक करें",
        SerialNumberHistory: "सीरियल नंबर हिस्ट्री",
        Trackproductserialnumberactivity: "प्रोडक्ट सीरियल नंबर की एक्टिविटी ट्रैक करें",
        Period: "पीरियड",
        Nohistoryfound: "कोई हिस्ट्री नहीं मिली",
        Searchserialnumbers: "सीरियल नंबर्स सर्च करें...",
        SerialNumbersHistory: "सीरियल नंबर्स हिस्ट्री",
        Serialnumberhistoryglance: "सीरियल नंबर हिस्ट्री एक नजर में।",
        Noserialnumbersfound: "कोई सीरियल नंबर नहीं मिला",
        Noactivityhistoryfound: "कोई एक्टिविटी हिस्ट्री नहीं मिली",
        Statussetto: "स्टेटस सेट किया गया",
        Timeline: "टाइमलाइन",
        Managereusableproductvariantpatterns: "रीयूजेबल प्रोडक्ट वैरिएंट पैटर्न्स मैनेज करें।",
        DeleteTemplate: "टेम्प्लेट डिलीट करें",
        Areyousureyouwanttemplate: "क्या आप इस टेम्प्लेट को डिलीट करना चाहते हैं?",
        CreateNewTemplate: "नया टेम्प्लेट बनाएं",
        CreateTemplate: "टेम्प्लेट बनाएं",
        EditTemplate: "टेम्प्लेट एडिट करें",
        UnlimitedTemplates: "अनलिमिटेड टेम्प्लेट्स",
        CreateAsManyTemplates: "जितने चाहें उतने टेम्प्लेट्स बनाएं — कपड़े, जूते, इलेक्ट्रॉनिक्स और भी बहुत कुछ।",
        PickWhileAddingProduct: "प्रोडक्ट ऐड करते समय चुनें",
        OpenTemplateLibrary: "अपनी टेम्प्लेट लाइब्रेरी खोलें और सेकंडों में वैरिएंट नाम चुनें।",
        MixFromMultipleTemplates: "मल्टीपल टेम्प्लेट्स से मिक्स करें",
        SelectFromMultipleTemplates: "एक प्रोडक्ट के लिए एक से ज्यादा टेम्प्लेट्स से वैरिएंट नाम चुनें — पूरी तरह फ्लेक्सिबल।",
        EditAnytime: "कभी भी एडिट करें",
        RenameTemplatesAnytime: "टेम्प्लेट का नाम बदलें, वैरिएंट नाम ऐड या रिमूव करें जब भी आपका कैटलॉग बदलता है।",
        StayConsistent: "कंसिस्टेंट रहें",
        SameVariantNamesAcrossAll: "सभी प्रोडक्ट्स में एक जैसे वैरिएंट नाम। कोई टाइपो नहीं, कोई डुप्लिकेट नहीं, कोई गेसवर्क नहीं।",
        BuildOnceUseEverywhere: "एक बार बनाएं, हर जगह इस्तेमाल करें",
        StopReEnteringVariantNames: "हर प्रोडक्ट के लिए बार-बार वैरिएंट नाम न लिखें। एक टेम्प्लेट बनाएं, वैरिएंट नाम असाइन करें और तुरंत दोबारा इस्तेमाल करें।",
        Updateexistingvariantcombinations: "मौजूदा वैरिएंट कॉम्बिनेशन्स अपडेट करें",
        Definenewvariantcombinations: "नए वैरिएंट कॉम्बिनेशन्स बनाएं",
        TemplateName: "टेम्प्लेट का नाम",
        AddVariantOptions: "वैरिएंट ऑप्शन्स ऐड करें",
        SmallMedium: "उदा. स्मॉल, मीडियम...",
        VariantsList: "वैरिएंट्स की लिस्ट",
        Nooptionsaddedyet: "अभी तक कोई ऑप्शन ऐड नहीं किया गया",
        SaveTemplate: "टेम्प्लेट सेव करें",
        egSizesColorsetc: "उदा. टी-शर्ट साइज, कलर्स, आदि।",
        Pleaseentertemplatename: "कृपया टेम्प्लेट का नाम दर्ज करें",
        Pleaseaddatleastonevariantoption: "कृपया कम से कम एक वैरिएंट ऑप्शन ऐड करें",
        Templateupdatedsuccessfully: "टेम्प्लेट सफलतापूर्वक अपडेट हो गया",
        Templatecreatedsuccessfully: "टेम्प्लेट सफलतापूर्वक बनाया गया",
        Failedtosavetemplate: "टेम्प्लेट सेव करने में विफल",
        Transfer: "ट्रांसफर",
        Editassignment: "असाइनमेंट एडिट करें",
        Updateproductdetailsinbin: "बिन में प्रोडक्ट डिटेल्स अपडेट करें",
        Editinginbin: "बिन में एडिटिंग हो रही है",
        ConfirmUpdate: "अपडेट की पुष्टि करें",
        ConfirmAssign: "असाइन की पुष्टि करें",
        Assignanotherproduct: "दूसरा प्रोडक्ट असाइन करें",
        TransferBin: "बिन ट्रांसफर करें",
        SourceBin: "सोर्स बिन",
        DestinationBin: "डेस्टिनेशन बिन",
        SelectSourceBin: "सोर्स बिन चुनें",
        SelectDestinationBin: "डेस्टिनेशन बिन चुनें",
        Unit: "यूनิต",
        ManageVariant: "वैरिएंट मैनेज करें",
        CreateSKUvariationsyourproduct: "अपने प्रोडक्ट के लिए SKU वैरिएशन्स बनाएं",
        Assigningvariationsto: "वैरिएशन्स असाइन किए जा रहे हैं",
        Novariantsaddedyet: "अभी तक कोई वैरिएंट्स ऐड नहीं किए गए",
        AddedVariants: "ऐड किए गए वैरिएंट्स",
        AddVariantsfromTemplate: "टेम्प्लेट से वैरिएंट्स ऐड करें",
        Pickatemplateandselectvariantnames: "टेम्प्लेट चुनें और वैरिएंट नाम चुनें",
        ChooseaTemplate: "टेम्प्लेट चुनें",
        Selectvariantnamestoadd: "ऐड करने के लिए वैरिएंट नाम चुनें",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "वैरिएंट नाम चुनने के लिए टेम्प्लेट चुनें। आप मल्टीपल से भी ऐड कर सकते हैं।",
        Loadingtemplates: "टेम्प्लेट्स लोड हो रहे हैं...",
        Backtotemplates: "टेम्प्लेट्स पर वापस जाएं",
        Selectallindividualadd: "सभी या अलग-अलग वैरिएंट नाम चुनकर ऐड करें।",
        VariantNames: "वैरिएंट नाम",
        MediaDescription: "मीडिया & विवरण",
        Addattachmentsandproductnotes: "अटैचमेंट और प्रोडक्ट नोट्स जोड़ें",
        ProductMedia: "प्रोडक्ट मीडिया"
    },
    AddProductGuide: {
        title: "सेव करने के बाद शुरुआती स्टॉक जोड़ें",
        description: "यहाँ प्रोडक्ट्स में मात्रा का फील्ड नहीं है। सेव करने के बाद, 'स्टॉक इन' का उपयोग करके अपना ओपनिंग स्टॉक लॉग करें — लोकेशन और ट्रैकिंग पर पूरा नियंत्रण।",
        steps: {
            quantity: { title: "मात्रा", sub: "ओपनिंग स्टॉक सेट करें" },
            binLocation: { title: "बिन लोकेशन", sub: "गलियारा, रैक, शेल्फ — उदाहरण: A-01-03" },
            serialNumbers: { title: "सीरियल नंबर", sub: "हर यूनिट को अलग-अलग ट्रैक करें" },
            warehouse: { title: "वेयरहाउस", sub: "किस लोकेशन पर स्टोर है" },
            batchExpiry: { title: "बैच / एक्सपायरी", sub: "बैच नंबर के अनुसार स्टॉक ग्रुप करें" }
        },
        actions: { close: "बंद करें" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "कोई ट्रांसफर ऑर्डर नहीं मिला",
        Itemshistory: "जिन आइटम्स को आप वेयरहाउस के बीच ट्रांसफर करते हैं, वे ट्रैकिंग और हिस्ट्री के लिए यहाँ दिखाई देंगे।",
        CreateTransfer: "ट्रांसफर बनाएं"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "मैन्युफैक्चर करने के लिए प्रोडक्ट पर टैप करें",
        Selectproductfrombelow: "नीचे दी गई लिस्ट से प्रोडक्ट चुनें",
        SetupANewProduct: "नया प्रोडक्ट सेटअप करें",
        DefineAProductAdditsrawmaterial: "प्रोडक्ट को परिभाषित करें और उसका कच्चा माल जोड़ें",
        ManufacturingSetup: "मैन्युफैक्चरिंग सेटअप",
        Pickproducttodefineitsproductiondetails: "प्रोडक्शन विवरण तय करने के लिए प्रोडक्ट चुनें",
        ConfigureManufacturing: "मैन्युफैक्चरिंग कॉन्फ़िगर करें",
        SelectRawMaterial: "कच्चा माल चुनें",
        NoRawMaterials: "कोई कच्चा माल नहीं",
        Definecomponentsneededtoproduct: "इस प्रोडक्ट को बनाने के लिए आवश्यक घटकों को परिभाषित करें।",
        NoAdditionalCosts: "कोई अतिरिक्त लागत नहीं",
        Addlaboroverheadlogisticalcharges: "श्रम, ओवरहेड या लॉजिस्टिक शुल्क जोड़ें।",
        AddAdditionalCost: "अतिरिक्त लागत जोड़ें",
        AddCost: "लागत जोड़ें",
        TotalPrice: "कुल मूल्य",
        SelectCharges: "शुल्क चुनें",
        EnterEstimatedCost: "अनुमानित लागत दर्ज करें",
        QtyRequried: "आवश्यक मात्रा",
        Manufacturing: "मैन्युफैक्चरिंग",
        Outputfinishedgoodsdestination: "तैयार माल का गंतव्य",
        Manufacturingquantity: "मैन्युफैक्चरिंग मात्रा",
        Storefinishedgoodsat: "तैयार माल यहाँ स्टोर करें",
        Rawmaterials: "कच्चा माल",
        StockSelection: "स्टॉक चयन",
        AdditionalCosts: "अतिरिक्त लागत",
        Quantityconsume: "खपत होने वाली मात्रा",
        Totalmanufacturingcost: "कुल मैन्युफैक्चरिंग लागत",
        Sumofrawmaterialcosts: "सभी कच्चे माल की लागत का योग",
        CustomManufacturingCharge: "कस्टम मैन्युफैक्चरिंग शुल्क",
        Addextralikelaboroverheadrepairs: "श्रम, ओवरहेड या मरम्मत जैसी अतिरिक्त लागतें जोड़ें।",
        CalculatedTotal: "गणना की गई कुल लागत",
        AddRawMaterial: "कच्चा माल जोड़ें",
        ConfigureRawMaterial: "कच्चा माल कॉन्फ़िगर करें",
        Thisoutputunit: "यह प्रति आउटपुट यूनिट के लिए आवश्यक मूल मात्रा है।",
        ChangeProduct: "प्रोडक्ट बदलें",
        AddtoList: "लिस्ट में जोड़ें",
        ManufacturedSuccessfully: "सफलतापूर्वक मैन्युफैक्चर किया गया",
        Manufacture: "निर्माण",
        EditDeleteHistory: "एडिट/डिलीट हिस्ट्री",
        ManageOrder: "ऑर्डर मैनेज करें",
        ManageBatch: "बैच मैनेज करें",
        Paymentnotavailablehere: "यहाँ भुगतान उपलब्ध नहीं है",
        Thisrecordisanorderorderitself: "यह रिकॉर्ड एक ऑर्डर से है। भुगतान केवल ऑर्डर से ही दर्ज किया जा सकता है।",
        Torecorpaymenttheorderthethere: "भुगतान दर्ज करने के लिए, लिंक किए गए ऑर्डर पर जाएं और वहां <b>भुगतान दर्ज करें</b> विकल्प का उपयोग करें.",
        GotoOrder: "ऑर्डर पर जाएं"
    },
    CustomerExcel: {
        title: "ग्राहक अपलोड करें",
        description: "एक्सेल फ़ाइल का उपयोग करके ग्राहकों को थोक में बनाने के लिए नीचे दिए गए चरणों का पालन करें।",
        bulkUploadGuide: "थोक अपलोड गाइड",
        step1: "चरण 1",
        downloadTemplate: "एक्सेल टेम्पलेट डाउनलोड करें",
        downloadTemplateDesc: "सभी आवश्यक कॉलम हेडर के साथ आधिकारिक टेम्पलेट प्राप्त करें।",
        downloadTemplateBtn: "टेम्पलेट डाउनलोड करें",
        step2: "चरण 2",
        fillExcelFile: "एक्सेल फ़ाइल भरें",
        fillExcelDesc: "प्रत्येक पंक्ति एक ग्राहक का प्रतिनिधित्व करती है। आवश्यकतानुसार सभी कॉलम भरें।",
        step3: "चरण 3",
        thingsToKeepInMind: "ध्यान रखने योग्य बातें",
        rulesDesc: "अपलोड करने से पहले, सुनिश्चित करें कि आपकी फ़ाइल त्रुटियों से बचने के लिए इन नियमों का पालन करती है।",
        step4: "चरण 4",
        uploadYourFile: "अपनी फ़ाइल अपलोड करें",
        uploadDesc: "भरने के बाद, नीचे फ़ाइल अपलोड करें। सिस्टम स्वचालित रूप से सभी ग्राहक बना देगा।",
        rules: [
            "केवल एक ग्राहक प्रति पंक्ति",
            "कॉलम हेडर का नाम न बदलें",
            "देश कोड के साथ संपर्क नंबर",
            "केवल .xlsx या .xls फ़ाइलें स्वीकार की जाती हैं"
        ],
        dropFileHere: "अपनी एक्सेल फ़ाइल यहाँ छोड़ें",
        supports: ".xlsx और .xls का समर्थन करता है — अधिकतम 10 एमबी",
        chooseFileUpload: "फ़ाइल चुनें और अपलोड करें",
        parsing: "फ़ाइल का विश्लेषण किया जा रहा है...",
        invalidFileType: "अमान्य फ़ाइल प्रकार। कृपया एक्सेल फ़ाइल अपलोड करें।",
        noData: "एक्सेल में कोई डेटा नहीं मिला",
        failedToRead: "एक्सेल फ़ाइल पढ़ने में विफल",
        unableToRead: "फ़ाइल पढ़ने में असमर्थ।",
        reviewTitle: "ग्राहक डेटा की समीक्षा करें",
        reviewSubtitle: "अपने व्यवसाय में आयात करने से पहले अंतिम जांच।",
        changeFile: "फ़ाइल बदलें",
        rowsFound: "फ़ाइल में पंक्तियाँ मिलीं",
        cancel: "रद्द करें",
        finalizeImport: "अंतिम रूप दें और आयात करें",
        importing: "आयात किया जा रहा है...",
        success: "सफलता",
        allCustomerUploadedSuccess: "सभी ग्राहक सफलतापूर्वक अपलोड किए गए",
        failed: "विफल",
        bulkUploadFailed: "थोक अपलोड विफल रहा",
        error: "त्रुटि",
        headers: {
            customerName: "ग्राहक का नाम",
            phoneNumber: "संपर्क",
            address: "पता",
            note: "नोट"
        }
    },
    SupplierExcel: {
        title: "विक्रेता अपलोड करें",
        description: "एक्सेल फ़ाइल का उपयोग करके विक्रेताओं को थोक में बनाने के लिए नीचे दिए गए चरणों का पालन करें।",
        bulkUploadGuide: "थोक अपलोड गाइड",
        step1: "चरण 1",
        downloadTemplate: "एक्सेल टेम्पलेट डाउनलोड करें",
        downloadTemplateDesc: "सभी आवश्यक कॉलम हेडर के साथ आधिकारिक टेम्पलेट प्राप्त करें।",
        downloadTemplateBtn: "टेम्पलेट डाउनलोड करें",
        step2: "चरण 2",
        fillExcelFile: "एक्सेल फ़ाइल भरें",
        fillExcelDesc: "प्रत्येक पंक्ति एक विक्रेता का प्रतिनिधित्व करती है। आवश्यकतानुसार सभी कॉलम भरें।",
        step3: "चरण 3",
        thingsToKeepInMind: "ध्यान रखने योग्य बातें",
        rulesDesc: "अपलोड करने से पहले, सुनिश्चित करें कि आपकी फ़ाइल त्रुटियों से बचने के लिए इन नियमों का पालन करती है।",
        step4: "चरण 4",
        uploadYourFile: "अपनी फ़ाइल अपलोड करें",
        uploadDesc: "भरने के बाद, नीचे फ़ाइल अपलोड करें। सिस्टम स्वचालित रूप से सभी विक्रेता बना देगा।",
        rules: [
            "केवल एक विक्रेता प्रति पंक्ति",
            "कॉलम हेडर का नाम न बदलें",
            "देश कोड के साथ संपर्क नंबर",
            "केवल .xlsx या .xls फ़ाइलें स्वीकार की जाती हैं"
        ],
        dropFileHere: "अपनी एक्सेल फ़ाइल यहाँ छोड़ें",
        supports: ".xlsx और .xls का समर्थन करता है — अधिकतम 10 एमबी",
        chooseFileUpload: "फ़ाइल चुनें और अपलोड करें",
        parsing: "फ़ाइल का विश्लेषण किया जा रहा है...",
        invalidFileType: "अमान्य फ़ाइल प्रकार। कृपया एक्सेल फ़ाइल अपलोड करें।",
        noData: "एक्सेल में कोई डेटा नहीं मिला",
        failedToRead: "एक्सेल फ़ाइल पढ़ने में विफल",
        unableToRead: "फ़ाइल पढ़ने में असमर्थ।",
        reviewTitle: "विक्रेता डेटा की समीक्षा करें",
        reviewSubtitle: "अपने व्यवसाय में आयात करने से पहले अंतिम जांच।",
        changeFile: "फ़ाइल बदलें",
        rowsFound: "फ़ाइल में पंक्तियाँ मिलीं",
        cancel: "रद्द करें",
        finalizeImport: "अंतिम रूप दें और आयात करें",
        importing: "आयात किया जा रहा है...",
        success: "सफलता",
        allSupplierUploadedSuccess: "सभी विक्रेता सफलतापूर्वक अपलोड किए गए",
        failed: "विफल",
        bulkUploadFailed: "थोक अपलोड विफल रहा",
        error: "त्रुटि",
        headers: {
            supplierName: "विक्रेता का नाम",
            phoneNumber: "संपर्क",
            bankName: "बैंक का नाम",
            accountHolderName: "खाता धारक का नाम",
            accountNumber: "खाता संख्या",
            note: "नोट"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "के साथ बदला गया",
        Noreplacementhistoryfound: "कोई बदलाव इतिहास नहीं मिला",
        Noreturnhistoryfound: "कोई वापसी इतिहास नहीं मिला",
        Productbeingreturned: "वापस किया जाने वाला उत्पाद",
        Required: "आवश्यक",
        Selectreturnedproduct: "वापस किया गया उत्पाद चुनें",
        Searchnamescanbarcode: "नाम, SKU से खोजें या बारकोड स्कैन करें",
        Browse: "ब्राउज़ करें",
        Stockhandling: "स्टॉक-इन हैंडलिंग",
        Stockinreturnedproduct: "वापस किए गए उत्पाद का स्टॉक-इन करें",
        Ontoinventory: "चालू — वापस की गई वस्तु फिर से इन्वेंट्री में जोड़ी जाएगी",
        Offreturnedonly: "बंद — वस्तु केवल वापस की गई के रूप में लॉग की जाएगी",
        Usedrestock: "पुनः स्टॉक करने पर लाभ समायोजन की गणना के लिए उपयोग किया जाता है",
        Willaddedbackconfirmation: "पुष्टि होने पर इन्वेंट्री में वापस जोड़ दिया जाएगा",
        Returnreason: "वापसी का कारण",
        Optional: "वैकल्पिक",
        SelectReason: "कारण चुनें",
        Additionalnotes: "अतिरिक्त टिप्पणियाँ",
        Describeofcustomerexplanation: "वापस की गई वस्तु की स्थिति, कोई भी दृश्य क्षति, ग्राहक का स्पष्टीकरण बताएं...",
        Requiredmustfilledcontinue: "आगे बढ़ने के लिए आवश्यक फ़ील्ड भरना अनिवार्य है",
        Reviewdetailsbeforeconfirming: "पुष्टि करने से पहले विवरण की समीक्षा करें",
        Replacementproductwilldeductedinventoryconfirmation: "बदला गया उत्पाद पुष्टि होने पर आपकी इन्वेंट्री से घटा दिया जाएगा।",
        Choosereplacementproduct: "बदलने वाला उत्पाद चुनें",
        Willdeductedfrominventoryconfirm: "पुष्टि होने पर इन्वेंट्री से घटा दिया जाएगा",
        Thesewillattachedothereturnrecord: "ये चित्र वापसी रिकॉर्ड के साथ संलग्न किए जाएंगे",
        Replacementitem: "बदली जाने वाली वस्तु",
        Addanotherproduct: "एक और उत्पाद जोड़ें",
        Replacementproductwillbe: "बदला गया उत्पाद",
        deducted: "घटा",
        fromyourinventoryconfirmation: "पुष्टि होने पर आपकी इन्वेंट्री से दिया जाएगा।",
        productadjustedusingprice: "वापस किए गए उत्पाद को पुनः स्टॉक किया जाएगा और मूल बिक्री मूल्य का उपयोग करके लाभ समायोजित किया जाएगा।",
        Willloggedreturnedonlynotrestocked: "केवल वापस किए गए के रूप में लॉग किया जाएगा — पुनः स्टॉक नहीं किया जाएगा",
        Returnonly: "केवल वापसी",
        Imagesofreturnedproduct: "वापस किए गए उत्पाद के चित्र",
        Returnedproductwill: "वापस किया गया उत्पाद",
        not: "नहीं",
        berestockedloggedreturnedonly: "पुनः स्टॉक किया जाएगा — केवल वापस किए गए के रूप में लॉग किया जाएगा।",
        AddImage: "छवि जोड़ें",
        STOCKIN: "स्टॉक-इन",
        LOGONLY: "केवल लॉग",
        ContinuetoReview: "समीक्षा के लिए आगे बढ़ें →",
        Confirmreplacement: "बदलाव की पुष्टि करें",
        Confirmreturn: "वापसी की पुष्टि करें",
        Filldetailsbelowproceed: "आगे बढ़ने के लिए नीचे विवरण भरें",
        Review: "समीक्षा",
        editdetails: "विवरण संपादित करें",
        Configurereturndetails: "वापसी विवरण कॉन्फ़िगर करें",
        Configurereplacementdetails: "बदलाव विवरण कॉन्फ़िगर करें",
        SelectSource: "स्रोत चुनें",
        Returning: "वापसी",
        Replacement: "बदलाव",
        WalkCustomer: "सीधे आने वाले ग्राहक",
        RETURNEDPRODUCT: "वापस किया गया उत्पाद",
        REPLACEMENTPRODUCT: "बदला गया उत्पाद",
        STOCKOUT: "स्टॉक-आउट",
        Netinventoryimpact: "शुद्ध इन्वेंट्री प्रभाव",
        Replacementitemcost: "बदले गए आइटम की लागत",
        Returneditemrestockvalue: "वापस किए गए आइटम का रीस्टॉक मूल्य",
        PROFITINVENTORYSUMMARY: "लाभ और इन्वेंट्री सारांश",
        Inventoryaction: "इवेंट्री कार्रवाई",
        Valuededucted: "घटाया गया मूल्य",
        Profitadjustment: "लाभ समायोजन",
        stockedout: " स्टॉक आउट हुआ",
        restocked: " रीस्टॉक हुआ",
        Noaction: "कोई कार्रवाई नहीं",
        Valuebeingreturned: "वापस किया जा रहा मूल्य",
        Willberestocked: "रीस्टॉक किया जाएगा",
        Willbe: "होगा",
        logged: "लॉग",
        ON: "चालू",
        OFF: "बंद",
        Linked: "लिंक्ड",
        Pleaseselectreturnedproduct: "कृपया रिटर्न किया गया प्रोडक्ट चुनें",
        Quantityrequired: "मात्रा आवश्यक है",
        Buyingpricerequired: "खरीद मूल्य आवश्यक है",
        Pleaseaddleastreplacementproduct: "कृपया कम से कम एक रिप्लेसमेंट प्रोडक्ट जोड़ें",
        Pleaseconfigurereturnedproductdetails: "कृपया रिटर्न किए गए प्रोडक्ट की डिटेल्स कॉन्फ़िगर करें",
        Pleaseselectcustomer: "कृपया एक ग्राहक चुनें",
        Returndateisrequired: "रिटर्न की तारीख आवश्यक है",
        Pleasefillallrequiredfields: "कृपया सभी आवश्यक फ़ील्ड भरें",
        Wildeductedfrominventory: "इन्वेंट्री से काटा जाएगा",
        Currentprice: "वर्तमान मूल्य",
        Defectivedamaged: "दोषपूर्ण / क्षतिग्रस्त",
        Wrongitemreceived: "गलत आइटम प्राप्त हुआ",
        Customerchangedmind: "ग्राहक ने मन बदला",
        Sizefitissue: "साइज़ / फ़िट समस्या",
        Notasdescribed: "विवरण के अनुसार नहीं",
        Other: "अन्य",
        Originalsaleprice: "मूल बिक्री मूल्य (लाभ समायोजित)",
        Addedbackinventory: "इन्वेंटरी में वापस जोड़ा गया",
        Notaddedinventory: "इन्वेंटरी में नहीं जोड़ा गया",
        replacedwith: "के साथ बदला गया",
        deductedfrominventory: "इन्वेंटरी से काटा गया",
        RETURNWITHSTOCKIN: "रिटर्न · स्टॉक-इन के साथ",
        RETURNNOSTOCKIN: "रिटर्न · स्टॉक-इन के बिना",
        MULTIPLEREPLACEMENTS: "एकाधिक प्रतिस्थापन",
        SINGLEREPLACEMENT: "सिंगल प्रतिस्थापन",
        InternalTrackingRecordInfo: "यह आंतरिक ट्रैकिंग के लिए एक रिकॉर्ड है। यह प्रक्रिया संबंधित इनवॉइस, ऑर्डर या खातों को स्वचालित रूप से अपडेट या डिलीट नहीं करती है।",
        ManualStepsIfNeeded: "मैनुअल चरण (यदि आवश्यक हो):",
        ManualStep1: "बिक्री इतिहास से इनवॉइस वापस करें/हटाएं",
        ManualStep2: "ग्राहक लेजर को मैन्युअल रूप से समायोजित करें",
        ManualStep3: "संबंधित खरीद रिकॉर्ड अपडेट करें",
        RETURNEDSTOCKIN: "रिटर्न्ड · स्टॉक इन",
        REPLACEMENTSTOCKOUT: "रिप्लेसमेंट · स्टॉक आउट",
        Returnonlylogsthisentry: "रिटर्न केवल इस प्रविष्टि को लॉग करता है —",
        nostockwillbeaddedorremoved: "कोई स्टॉक जोड़ा या हटाया नहीं जाएगा",
        frominventory: "इन्वेंट्री से।",
        Whentousethis: "इसका उपयोग कब करें:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "दिन के अंत में उन वस्तुओं को रिकॉर्ड करने के लिए रिटर्न का उपयोग करें जो बिक्री के लिए भेजी गई थीं और क्षतिग्रस्त या अनुपयोगी होकर वापस आईं — वे वस्तुएं जिन्हें आप ट्रैक करना चाहते हैं लेकिन इन्वेंट्री में वापस नहीं जोड़ सकते।",
        Youcanviewallpastreturnentriesin: "आप पिछली सभी रिटर्न प्रविष्टियाँ यहाँ देख सकते हैं",
        ReturnHistory: "रिटर्न इतिहास",
        underthe: "के अंतर्गत",
        Others: "अन्य",
        tab: "टैब।",
        Negativestocktransactiondisabled: "नकारात्मक स्टॉक लेन-देन अक्षम हैं।"
    },
    NewRLocal: {
        Originalsaleprice: "मूल बिक्री मूल्य",
        Editinghistoryonlyinventorystaysunchanged: "केवल इतिहास संपादित किया जा रहा है — इन्वेंट्री अपरिवर्तित रहती है।",
        Changeshereupdatethisdetailsquantitiesaffected: "यहां किए गए बदलाव केवल इस रिकॉर्ड के विवरण (कारण, तिथि, नोट्स) को अपडेट करते हैं। आपकी वास्तविक स्टॉक मात्रा, बिन स्थान और उत्पाद डेटा प्रभावित नहीं होते हैं।",
        Needtofixinventorylevelsinstead: "इसके बजाय इन्वेंट्री स्तरों को ठीक करने की आवश्यकता है?",
        AdjustStock: "स्टॉक समायोजित करें",
        Refund: "धनवापसी",
        ImportantNote: "महत्वपूर्ण नोट",
        Pleasereviewbeforecontinuing: "आगे बढ़ने से पहले कृपया समीक्षा करें",
        Onceshippedreceivedanyupdatesmadeorder: "एक बार ऑर्डर भेज दिए जाने या प्राप्त होने के बाद, ऑर्डर में किया गया कोई भी अपडेट ट्रांजैक्शन हिस्ट्री में दिखाई नहीं देगा।",
        Thisundone: "यह स्थायी रूप से ऑर्डर को हटा देगा। इस कार्रवाई को पूर्ववत नहीं किया जा सकता है।",
        Inventorywilladjustedautomatically: "इन्वेंट्री स्वचालित रूप से समायोजित नहीं होगी",
        Deletingthisreversevedshippedyouwillneed: "इसे हटाने से स्टॉक में कोई बदलाव नहीं होता है। यदि आइटम पहले ही प्राप्त/भेजे जा चुके हैं, तो आपको आवश्यकता होगी",
        reflectthecorrectstocklevels: "सही स्टॉक स्तर दिखाने के लिए।",
        manuallyadjustyourinventory: "अपनी इन्वेंट्री को मैन्युअल रूप से समायोजित करें",
        Addremovestockforitemsthatwereshipped: "उन वस्तुओं के लिए स्टॉक जोड़ें या निकालें जो भेज दी गई थीं",
        Addremovestockforitemsthatwerereceived: "उन वस्तुओं के लिए स्टॉक जोड़ें या निकालें जो प्राप्त हुई थीं",
        Updatecostrecordspaymentwaalreadymade: "यदि भुगतान पहले ही किया जा चुका है तो लागत रिकॉर्ड अपडेट करें",
        Reconcilerecordsandoutstandingpayments: "रिकॉर्ड और बकाया भुगतान का मिलान करें"
    },
    ReceivablesLocal: {
        Receivables: "प्राप्य",
        Manageandtrackcustomerduebalances: "ग्राहकों के बकाया बैलेंस का प्रबंधन और ट्रैकिंग करें",
        Viewcustomerduebalancereport: "ग्राहक बकाया बैलेंस रिपोर्ट देखें",
        Viewsupplierduebalancereport: "सप्लायर बकाया बैलेंस रिपोर्ट देखें",
        DueBalance: "बकाया राशि",
        Unpaid: "अभुक्त",
        PartiallyPaid: "आंशिक रूप से भुगतान",
        Paid: "भुगतान किया गया",
        HighestBalance: "सबसे अधिक बैलेंस",
        LowestBalance: "सबसे कम बैलेंस",
        Filldetailsrecordpayment: "भुगतान दर्ज करने के लिए विवरण भरें",
        NewPaymentEntry: "नई भुगतान प्रविष्टि",
        EditPaymentEntry: "भुगतान प्रविष्टि संपादित करें",
        Nosuppliersfound: "कोई सप्लायर नहीं मिला",
        Nocustomersfound: "कोई ग्राहक नहीं मिला",
        LowtoHigh: "कम से अधिक",
        HightoLow: "अधिक से कम",
        AttachmentUploadedSc: "अटैचमेंट सफलतापूर्वक अपलोड हो गया",
        AttachmentUploadedF: "अटैचमेंट अपलोड करने में विफल",
        Pay: "भुगतान करें",
        NoBillsFound: "कोई बिल नहीं मिला",
        Thiscustomerhasunpaidbills: "इस ग्राहक के पास कोई बकाया बिल नहीं है।",
        TotalDue: "कुल बकाया",
        BillsFound: "बिल मिले",
        DeselectAll: "सभी unselected करें",
        SelectAll: "सभी चुनें",
        ShowDetails: "विवरण दिखाएं"
    },
    AssetsNewLocal: {
        Assignedon: "सौंपा गया की तारीख",
        Total: "कुल",
        Assigned: "सौंपा गया",
        Remaining: "शेष",
        Available: "उपलब्ध",
        NoSerialNumbers: "कोई सीरियल नंबर नहीं",
        UpdateExistingAssetDetails: "मौजूदा एसेट विवरण अपडेट करें",
        RegisterNewBusinessAsset: "नया व्यावसायिक एसेट पंजीकृत करें",
        BasicInformation: "बुनियादी जानकारी",
        AssetDetails: "एसेट विवरण",
        Quantity: "मात्रा",
        SerialNumbers: "सीरियल नंबर",
        SerialNumberPlaceholder: "सीरियल नंबर",
        AddSerialNumber: "सीरियल नंबर जोड़ें",
        SerialNumbersOptional: "सीरियल नंबर वैकल्पिक हैं। आप अधिकतम जोड़ सकते हैं",
        AssetImages: "एसेट छवियां",
        AdditionalNotes: "अतिरिक्त नोट्स",
        AdditionalNotesPlaceholder: "कोई भी अतिरिक्त विवरण या रखरखाव इतिहास...",
        Updating: "अपडेट किया जा रहा है...",
        Adding: "जोड़ा जा रहा है...",
        ITEquipmentPlaceholder: "जैसे आईटी उपकरण",
        LoadingMoreActivities: "अधिक गतिविधियों को लोड किया जा रहा है...",
        AssignedAssets: "सौंपे गए एसेट्स",
        Noassetsassignedstaffmember: "इस स्टाफ सदस्य को कोई एसेट सौंपा नहीं गया।",
        Assignassetstaff: "स्टाफ को एसेट असाइन करें",
        Returnassetfromstaff: "स्टाफ से यह एसेट वापस लें",
        AssignmentDetails: "असाइनमेंट विवरण",
        Serial: "सीरियल",
        ViewAssets: "सभी एसेट्स देखें",
        ViewByStaff: "स्टाफ अनुसार देखें",
        AssignedHistory: "असाइनमेंट इतिहास",
        Returned: "वापस लिया गया",
        Returnedon: "वापसी की तारीख",
        ReturnedBy: "वापस करने वाला",
        AssignedTo: "सौंपा गया",
        NoHistoryRecords: "कोई इतिहास रिकॉर्ड नहीं",
        Selectstaffmemberviewtheirassets: "उनके एसेट्स देखने के लिए स्टाफ सदस्य चुनें",
        Deleted: "हटाया गया",
        searchPlaceholder: "नाम या सीरियल नंबर से एसेट खोजें..."
    },
    InventoryCountLocale: {
        InventoryCount: "इन्वेंट्री काउंट",
        Viewinventorycountreport: "इन्वेंट्री काउंट रिपोर्ट देखें",
        ItemsCount: "आइटम्स की संख्या",
        All: "सभी",
        InProgress: "प्रगति में",
        Submitted: "सबमिट किया गया",
        awaitingreview: "समीक्षा की प्रतीक्षा में",
        EditInventoryCount: "इन्वेंट्री काउंट संपादित करें",
        NewInventoryCount: "नई इन्वेंट्री काउंट",
        Modifyinventorycountsheetdetails: "इन्वेंट्री काउंट शीट विवरण संशोधित करें",
        Startanewinventorycountsheet: "नई इन्वेंट्री काउंट शीट शुरू करें",
        GeneralInformation: "सामान्य जानकारी",
        Title: "शीर्षक",
        SaveChanges: "परिवर्तन सहेजें",
        Selectproductsforthisinventorycountsheet: "इस शीट के लिए उत्पाद चुनें",
        InventoryCountDetails: "इन्वेंट्री काउंट विवरण",
        Inventorycountsheetdetails: "इन्वेंट्री काउंट शीट विवरण",
        Viewingdetailsforcountsheet: "काउंट शीट का विवरण देख रहे हैं",
        Started: "शुरू किया",
        TaskSheets: "टास्क शीट्स",
        Allitems: "सभी आइटम्स",
        NotStarted: "शुरू नहीं हुआ",
        Completed: "पूर्ण",
        Results: "परिणाम",
        ViewResults: "परिणाम देखें",
        DeleteInventoryCount: "इन्वेंट्री काउंट हटाएं",
        Viewingtransactionandadjustments: "ट्रांजेक्शन लॉग और स्टॉक एडजस्टमेंट देख रहे हैं",
        Productsadjusted: "समायोजित उत्पाद",
        Assignee: "सौंपा गया",
        Tasksheetdetails: "टास्क शीट विवरण",
        Draft: "ड्राफ्ट",
        VariantQuantities: "वेरिएंट मात्राएं",
        AssignedProducts: "सौंपे गए उत्पाद",
        ReturnAsset: "एसेट वापस करें",
        EditTasksheet: "टास्क शीट संपादित करें",
        NewTasksheet: "नई टास्क शीट",
        Updatetasksheetdetails: "टास्क शीट विवरण अपडेट करें",
        Starttasksheetforthisinventorycount: "इस इन्वेंट्री काउंट के लिए नई टास्क शीट शुरू करें",
        TaskSheetInformation: "टास्क शीट जानकारी",
        SheetTitle: "शीट शीर्षक",
        Entersheettitle: "शीट शीर्षक दर्ज करें",
        SubmissionResult: "सबमिशन परिणाम",
        ReviewChanges: "परिवर्तनों की समीक्षा करें",
        Viewingsubmissionresultsforthisinventorycount: "इस इन्वेंट्री काउंट के सबमिशन परिणाम देख रहे हैं",
        Reviewyourinventorycountbeforesubmitting: "सबमिट करने से पहले अपनी इन्वेंट्री काउंट की समीक्षा करें"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "काउंट लोड करने में विफल",
        NoInventoryCounts: "कोई इन्वेंट्री काउंट नहीं",
        NoMatches: "कोई मैच नहीं",
        Therearenoinventorycountswiththestatus: "इस स्टेटस के साथ कोई इन्वेंट्री काउंट नहीं है",
        Noinventorycountsfoundyoursearchterm: "आपके सर्च टर्म से मेल खाने वाला कोई इन्वेंट्री काउंट नहीं मिला।",
        Thereareinventorycountsrecordedyetforthisbusiness: "इस व्यवसाय के लिए अभी तक कोई इन्वेंट्री काउंट दर्ज नहीं किया गया है।"
    },
    StockinModalP: {
        StockInNow: "अभी स्टॉक इन करें",
        Settheopeningquantityforthisproductrightnow: "इस उत्पाद के लिए शुरुआती मात्रा अभी सेट करें।",
        Addinitialstock: "शुरुआती स्टॉक जोड़ें?",
        dothislater: "मैं यह बाद में करूंगा",
        Productadded: "उत्पाद जोड़ा गया!",
        isready: "तैयार है।",
        SeeHowItWorks: "देखें कैसे काम करता है",
        NoSalesOrdersFound: "कोई सेल्स ऑर्डर नहीं मिला",
        NoPurchaseOrdersFound: "कोई खरीद ऑर्डर नहीं मिला",
        Startcreatingoutgoinginventoryrevenue: "सेल्स ऑर्डर बनाना शुरू करें ताकि आप अपने आउटगोइंग इन्वेंट्री और रेवेन्यू को ट्रैक कर सकें।",
        Trackrestockssupplierplace: "अपने इन्वेंट्री रीस्टॉक और सप्लायर ऑर्डर को एक जगह ट्रैक करें।",
        CreateSalesOrder: "सेल्स ऑर्डर बनाएं",
        CreatePurchaseOrder: "खरीद ऑर्डर बनाएं",
    }
    ,
    dialy_report: "दैनिक मूवमेंट रिपोर्ट",
    Quotation: "कोट",
    Quote: "कोट",
    Assignee: "सौंपा गया",
    dayStart: "दिन की शुरुआत",

    ShowTotalAmount: "कुल राशि",


    tutorial: {
        watchTitle: 'चरण-दर-चरण ट्यूटोरियल देखें',
        watchDesc: 'हमारे YouTube चैनल पर SimplyStock सीखें',
        modalTitle: 'SimplyStock के साथ आगे रहें',
        modalDesc: 'ट्यूटोरियल आते ही प्राप्त करने के लिए सदस्यता लें',
        feature1Title: 'नई सुविधा वॉकथ्रू',
        feature1Sub: 'हर नया अपडेट एक छोटे वीडियो के साथ समझाया गया — ताकि आप कभी नया अपडेट न चूकें',
        feature2Title: 'त्वरित वीडियो गाइड',
        feature2Sub: '5 मिनट से कम समय में स्टॉक, चालान, कर्मचारी पहुंच और बहुत कुछ सेट करें',
        feature3Title: 'त्वरित सूचनाएं',
        feature3Sub: 'एक नया ट्यूटोरियल लाइव होने पर तुरंत सूचना प्राप्त करें — अपनी गति से सीखें',
        feature4Title: 'हमेशा 100% मुफ़्त',
        feature4Sub: 'सभी ट्यूटोरियल हमेशा के लिए मुफ़्त हैं — किसी लॉगिन या सदस्यता की आवश्यकता नहीं है',
        subscribeBtn: 'SimplyStock की सदस्यता लें',
        maybeLater: 'बाद में शायद'
    }
    ,
    dailyCashReport: {
        "title": "दैनिक नकद रिपोर्ट",
        "subtitle": "किसने क्या भुगतान किया, किस तारीख को, और क्या बकाया है — बिक्री विवरण से समूहीकृत।",
        "totalSales": "कुल बिक्री",
        "cashReceived": "कुल प्राप्त",
        "outstanding": "बकाया",
        "collectionRate": "संग्रह दर",
        "grandTotalAllDates": "कुल योग (सभी तिथियां)",
        "totalLabel": "कुल",
        "loading": "लोड हो रहा है...",
        "noData": "चयनित तिथि सीमा के लिए कोई डेटा नहीं मिला।",
        "loadingMore": "और लोड हो रहा है..."
    },
    dailyCashReportColumns: {
        "date": "तारीख",
        "customer": "ग्राहक",
        "productsSold": "बेचे गए उत्पाद",
        "products": "उत्पाद",
        "salesAmount": "बिक्री राशि",
        "sales": "बिक्री",
        "received": "कुल प्राप्त",
        "receivedShort": "प्राप्त",
        "debited": "लेजर में डेबिट किया गया",
        "due": "देय",
        "paymentModes": "भुगतान का प्रकार",
        "mode": "प्रकार"
    }
}

export default hi
